<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-dialog v-model="loginDialog" persistent max-width="430">
                <v-card class="gray-border" style="font-family: Arial; font-size: smaller !important; overflow: hidden;">
                    <v-card-title style="font-size: 24px; justify-content: center; color:#EC6A30FF" >
                            Event Portal
                            <template>
                                <v-sheet class="mx-auto" width="300">
                                    <v-form fast-fail @submit.prevent>
                                        <v-text-field
                                            v-model="username"
                                            :rules="usernameRules"
                                            style="color: black;"
                                            label="Username"
                                            color="#EC6A30FF"
                                            autofocus>
                                        </v-text-field>
                                        <v-text-field
                                            v-model="password"
                                            :rules="passwordRules"
                                            :type="showPassword ? 'text' : 'password'"
                                            @keyup.enter="loginClicked"
                                            @click:append="showPassword = !showPassword"
                                            style="color: #EC6A30FF; font-family: Impact;"
                                            label="Password"
                                            color="#EC6A30FF"
                                            append-icon="mdi-eye"
                                        >
                                        </v-text-field>
                                    </v-form>
                                </v-sheet>
                            </template>
                    </v-card-title>
                    <v-divider :thickness="50"></v-divider>
                    <div class="pa-1" style="display: flex; justify-content: center;">
                    <!-- <v-btn @click="reloadPage" class="orange-border underline-animation-black" color="red" dark style="margin-right: 5px;">
                    <span style="color: black;">
                        <v-icon size="30"  class="flipped-icon>
                        mdi-home-export-outline
                        </v-icon>
                        Return
                    </span>
                    </v-btn> -->
                        <v-btn @click="loginClicked" small class="orange-border underline-animation-black" color="#17468f" dark>
                            <span style="color: white;">
                                <v-icon size="30">
                                mdi-login
                                </v-icon>
                                Log in
                            </span>
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
            <v-container fluid class="pa-0">
                <v-row no-gutters v-if="token" class="system_admin_background_color">
                    <v-col cols="12">	
                        <v-row no-gutters class="system_admin_toolbar_color">
                            <v-col cols="10" sm="10" md="10" lg="8" class="px-2">
                                <template v-if="!$vuetify.breakpoint.mdAndDown">
                                    <span class="system_admin_toolbar_color system_admin_font_toolbar_color"  cols="9" v-if="user.super_admin">Your Apps:</span>
                                    <v-btn plain :to="{ name: 'RaffleDraw', params: { id: encodeBase64(GET_EVENT_ID) } }" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">Raffle Draw</span>
                                            <v-icon class="system_admin_icon_toolbar_color" size="24" center>
                                            mdi-trophy
                                            </v-icon>
                                    </v-btn>
                                    <v-btn plain :to="{path: `/nomination/${encodeBase64('M')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">MR Nominees</span>
                                        <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                        mdi-vote
                                        </v-icon>
                                    </v-btn>
                                    <v-btn plain :to="{path: `/nomination/${encodeBase64('F')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">MS Nominees</span>
                                        <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                        mdi-vote
                                        </v-icon>
                                    </v-btn>
                                    <v-btn plain :to="{path: `/vote_list/${encodeBase64('M')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">MR Vote List</span>
                                        <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                        mdi-trophy-award
                                        </v-icon>
                                    </v-btn>
                                    <v-btn plain :to="{path: `/vote_list/${encodeBase64('F')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">MS Vote List</span>
                                        <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                        mdi-trophy-award
                                        </v-icon>
                                    </v-btn>
                                    <v-btn plain :to="{path: `/qr_scan`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;" v-if="user.super_admin">
                                        <span class="system_admin_font_toolbar_color" style="color:white">SCAN QR</span>
                                        <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                        mdi-qrcode-scan
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <span v-if="user.super_admin">
                                        Your Apps:
                                    </span>
                                    <v-menu offset-y v-if="user.super_admin">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" class="system_redirect_button_color">
                                                    <v-icon>mdi-apps</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense color="#17468f">
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-btn plain :to="{ name: 'RaffleDraw', params: { id: encodeBase64(GET_EVENT_ID) } }" target="_blank" class="underline-animation-black system_admin_font_family_primary" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">Raffle Draw</span>
                                                        <v-icon class="system_admin_icon_toolbar_color" size="24" center>
                                                        mdi-trophy
                                                        </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-btn plain :to="{path: `/nomination/${encodeBase64('M')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">MR Nominees</span>
                                                    <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                                    mdi-vote
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-btn plain :to="{path: `/nomination/${encodeBase64('F')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">MS Nominees</span>
                                                    <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                                    mdi-vote
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-btn plain :to="{path: `/vote_list/${encodeBase64('M')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">MR Vote List</span>
                                                    <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                                    mdi-trophy-award
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-btn plain :to="{path: `/vote_list/${encodeBase64('F')}/${encodeBase64(GET_EVENT_ID)}`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">MS Vote List</span>
                                                    <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                                    mdi-trophy-award
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary" v-if="user.super_admin">
                                                <v-btn plain :to="{path: `/qr_scan`}" target="_blank" class="underline-animation-black" style="font-size: 13px; height: 45px;">
                                                    <span class="system_admin_font_toolbar_color" style="color:white">SCAN QR</span>
                                                    <v-icon size="24" class="system_admin_icon_toolbar_color" center>
                                                    mdi-qrcode-scan
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="2" sm="2" md="1" lg="4" class="text-md-end d-flex justify-end pr-3">
                                <!-- Desktop view: Show full controls -->
                                <template v-if="!$vuetify.breakpoint.mdAndDown">
                                    <v-tooltip bottom color="#fea30b">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                            @click="generateClientQR()"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="system_redirect_button_color"
                                            text
                                            >
                                            <v-icon>mdi-qrcode</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:white;">Generate Client QR</span>
                                    </v-tooltip>

                                    <v-tooltip bottom color="#fea30b">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                            @click="redirectToEvent()"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="system_redirect_button_color"
                                            text
                                            >
                                            <v-icon>mdi-link-circle-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span style="color:white;">Redirect To Event</span>
                                    </v-tooltip>

                                    <span class="system_admin_font_toolbar_color">
                                        {{ dropdowns.event_list.find((x) => x.id == GET_EVENT_ID)?.name ?? null }}
                                    </span>

                                    <v-menu offset-y bottom left :close-on-click="true" :close-on-content-click="true">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon class="system_admin_icon_toolbar_color">mdi-list-box-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense color="#17468f">
                                            <v-list-item
                                            v-for="(event, i) in dropdowns.event_list"
                                            :key="i"
                                            link
                                            @click="selectEvent(event.id,event.name)"
                                            style="color:white;"
                                            class="system_admin_font_family_primary"
                                            >
                                                <v-icon class="system_admin_icon_toolbar_color" size="20">
                                                    {{ event.id == GET_EVENT_ID ? 'mdi-account-check' : 'mdi-account' }}
                                                </v-icon>
                                                <v-list-item-title class="system_admin_icon_toolbar_color"> {{ event.name }} </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>

                                    <v-menu offset-y bottom left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn dark icon v-bind="attrs" v-on="on">
                                                <v-icon class="system_admin_icon_toolbar_color">mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense color="#17468f">
                                            
                                            <v-list-item @click="openChangePasswordModal()" style="color:white;" class="system_admin_font_family_primary">
                                                <v-icon color="white" size="16">mdi-lock-reset</v-icon>
                                                <v-list-item-title>Change Password</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="logout" style="color:white;" class="system_admin_font_family_primary">
                                                <v-icon color="white" size="16">mdi-logout</v-icon>
                                            <v-list-item-title>Logout</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item class="system_admin_font_family_primary">
                                                <v-list-item-title>Hello! {{ someOtherData.name }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>

                                <!-- Tablet/Mobile view: Condensed v-menu -->
                                <template v-else>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on" class="system_redirect_button_color">
                                            <v-icon>mdi-menu</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list dense color="#17468f">
                                            <v-list-item @click="generateClientQR" class="system_admin_font_family_primary" style="color:white;">
                                            <v-icon class="mr-2">mdi-qrcode</v-icon>
                                            <v-list-item-title>Generate Client QR</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="redirectToEvent" class="system_admin_font_family_primary" style="color:white;">
                                            <v-icon class="mr-2">mdi-link-circle-outline</v-icon>
                                            <v-list-item-title>Redirect To Event</v-list-item-title>
                                            </v-list-item>

                                            <v-subheader class="white--text">Current Event</v-subheader>
                                            <v-list-item-group>
                                            <v-list-item
                                                v-for="(event, i) in dropdowns.event_list"
                                                :key="i"
                                                @click="selectEvent(event.id, event.name)"
                                                style="color:white;"
                                            >
                                                <v-icon class="mr-2">
                                                {{ event.id == GET_EVENT_ID ? 'mdi-account-check' : 'mdi-account' }}
                                                </v-icon>
                                                <v-list-item-title>{{ event.name }}</v-list-item-title>
                                            </v-list-item>
                                            </v-list-item-group>

                                            <v-divider></v-divider>

                                            <v-list-item class="system_admin_font_family_primary">
                                            <v-list-item-title>Hello! {{ someOtherData.name }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="openChangePasswordModal()" class="system_admin_font_family_primary" style="color:white;">
                                            <v-icon color="white" size="16">mdi-lock-reset</v-icon>
                                            <v-list-item-title>Change Password</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="logout" class="system_admin_font_family_primary" style="color:white;">
                                            <v-icon color="white" size="16">mdi-logout</v-icon>
                                            <v-list-item-title>Logout</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-col>
                        </v-row>
                        <v-dialog v-model="changePasswordModal" width="50%" persistent>
                            <v-card style="font-family: Evogria; font-size: smaller !important; overflow: hidden;" class="system_dialog_color system_admin_font_family_primary">
                                <v-card-title 
                                    class="justify-content-center white--text system_dialog_color system_dialog_font_color" 
                                    style="font-size: 24px; position: relative;"
                                    >
                                        <v-btn 
                                            @click="closeChangePasswordModal()" 
                                            plain 
                                            text 
                                            icon 
                                            color="red" 
                                            style="position: absolute; top: 0; right: 0;"
                                        >
                                            <v-icon class="system_dialog_font_color">mdi-window-close</v-icon>
                                        </v-btn>
                                    <span class="system_dialog_font_color">Change Password</span>
                                </v-card-title>
                                <v-card style="background-color: black;">
                                <v-card-text class="system_dialog_color">
                                    <v-row no-gutters>
                                    <v-col cols="12" class="px-3">
                                        <v-text-field
                                        label="Current Password"
                                        v-model="form.currentPassword"
                                        dense
                                        outlined
                                        type="password"
                                        ></v-text-field>
                                    </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                    <v-col cols="12" class="px-3">
                                        <v-text-field
                                        v-model="form.newPassword"
                                        label="New Password"
                                        dense
                                        outlined
                                        type="password"
                                        ></v-text-field>
                                    </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                    <v-col cols="12" class="px-3">
                                        <v-text-field
                                        v-model="form.newPasswordConfirmation"
                                        label="Confirm Password"
                                        dense
                                        outlined
                                        type="password"
                                        @keyup.enter="changePassword()"
                                        ></v-text-field>
                                    </v-col>
                                    </v-row>
                                </v-card-text>

                                <!-- <v-divider :thickness="20"></v-divider> -->

                                <div class="d-flex justify-content-center system_dialog_color">
                                    <v-btn class="system_dialog_button_color" dark x-large @click="changePassword()">
                                    Save
                                    </v-btn>
                                </div>
                                </v-card>
                            </v-card>
                        </v-dialog>
                        <v-row no-gutters class=" system_sub_admin_toolbar_color">
                            <v-col>
                                <v-tabs v-model="tab.index"  color="cyan" slider-color="cyan" background-color="#424242" dark show-arrows>
                                <v-tabs-slider color="#EC6A30FF"></v-tabs-slider>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(0)" :disabled="loading.datatable">
                                        <span class="system_sub_font_toolbar_color">Guest List</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(1)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Company List</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(2)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Raffle Prizes</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(3)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Activities</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(4)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Program Flow</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(5, {gender: nominee_tabs[n_tab].gender}), $store.commit('GENDER', nominee_tabs[n_tab].gender);" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Event Nominees</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(6)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Event Sitemap</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(7)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Event Details</span>
                                    </v-tab>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(8)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">Admin User</span>
                                    </v-tab>
                                    <v-spacer class="system_sub_admin_toolbar_color"></v-spacer>
                                    <v-tab ripple class="underline-animation-black system_sub_admin_toolbar_color" @click="resetPagination(), getTableData(9)" :disabled="loading.datatable" v-if="user.super_admin">
                                        <span class="system_sub_font_toolbar_color">General Settings</span>
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="tab.index" touchless>
                                    <!-- ALL Guests TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="guest_headers" 
                                            :items="filteredGuestItems" 
                                            :loading="loading.datatable"
                                            :items-per-page="-1"
                                            :height="getScreenHeight()"
                                            show-select
                                            loading-text="Loading... Please wait"
                                            class="elevation-1 orange-border system_admin_table_color" 
                                            hide-default-footer
                                            fixed-header
                                            @toggle-select-all="selectAllGuest($event)"
                                            >
                                            <template v-slot:[`header.full_name`]="{ header }">
                                                <span class="system_tableheader_color" style="align-items: center; margin-right:100px;">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.company_name`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.company_pax`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.table_num`]="{ header }">
                                                <span class="system_tableheader_color text-center">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.time_in`]="{ header }"> 
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.attended`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.not_attended`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.actions`]="{ header }">
                                                <span class="system_tableheader_color text-center">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:top>
                                                <v-container fluid class="system_admin_font_family_primary">
                                                    <v-row no-gutters>
                                                        <v-col cols="4" sm="4" lg="3" class="system_admin_font_family_primary">
                                                            <v-row no-gutters class="d-flex align-center">
                                                                <!-- Add Guest Button -->
                                                                <v-col cols="12" sm="4" lg="3" xl="3" class="d-flex justify-center">
                                                                    <v-dialog v-model="addParticipantDialog" max-width="1000" persistent>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn plain v-bind="attrs" v-on="on" class="underline-animation-black mt-2" style="font-size: 13px;">
                                                                            <span style="color:white;">Add Guest</span>
                                                                            <v-icon size="24" color="white">mdi-account-plus</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <!-- Add Guest Dialog Content -->
                                                                        <v-card style="font-family: Evogria; font-size: smaller !important; overflow: hidden;" height="80%" class="system_dialog_color system_admin_font_family_primary">
                                                                            <v-card-title class="justify-content-center align-items-start white--text system_dialog_color system_dialog_font_color" style="font-size: 24px;">
                                                                                <span class="system_dialog_font_color" style="font-size: 20px;">Add Guest</span>
                                                                                <v-btn @click="toggeaddParticipantDialog" plain text icon color="red" class="align-start" style="left: 350px;">
                                                                                    <v-icon class="system_dialog_font_color">mdi-window-close</v-icon>
                                                                                </v-btn>
                                                                            </v-card-title>
                                                                            <v-divider :thickness="50"></v-divider>
                                                                            <v-card style="background-color: black;">
                                                                                <v-card-text class="system_dialog_color">
                                                                                    <v-container>
                                                                                        <v-row
                                                                                            no-gutters
                                                                                            v-if="settings.data_grouping == 1"
                                                                                            class="d-flex align-center mb-4"
                                                                                        >
                                                                                            <!-- Text Field -->
                                                                                            <v-col cols="10" class="d-flex align-center pr-2">
                                                                                                <span>Reference #:</span>
                                                                                                <v-text-field
                                                                                                v-model="generatedref"
                                                                                                disabled
                                                                                                dense
                                                                                                hide-details
                                                                                                ></v-text-field>
                                                                                            </v-col>

                                                                                            <!-- Button -->
                                                                                            <v-col cols="2">
                                                                                                <v-btn
                                                                                                @click="generateReference"
                                                                                                small
                                                                                                outlined
                                                                                                block
                                                                                                >
                                                                                                Generate
                                                                                                </v-btn>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters>
                                                                                            <v-col cols="4">
                                                                                                <v-text-field 
                                                                                                    v-model="addParticipantLastName" 
                                                                                                    label="Last Name" 
                                                                                                    outlined
                                                                                                    dense 
                                                                                                    @input="addParticipantLastName = addParticipantLastName.toUpperCase()" 
                                                                                                    ></v-text-field>
                                                                                            </v-col>
                                                                                            <v-col cols="4">
                                                                                                <v-text-field 
                                                                                                    v-model="addParticipantFirstName" 
                                                                                                    label="First Name" 
                                                                                                    class="pl-2"
                                                                                                    outlined
                                                                                                    dense 
                                                                                                    @input="addParticipantFirstName = addParticipantFirstName.toUpperCase()" 
                                                                                                >
                                                                                                </v-text-field>
                                                                                            </v-col>
                                                                                            <v-col cols="4">
                                                                                                <v-text-field 
                                                                                                    label="Middle Name" 
                                                                                                    v-model="addParticipantMiddleName" 
                                                                                                    class="pl-2"
                                                                                                    outlined
                                                                                                    dense 
                                                                                                    @input="addParticipantMiddleName = addParticipantMiddleName.toUpperCase()" 
                                                                                                >
                                                                                                </v-text-field>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                            <v-col cols="12">
                                                                                                <v-autocomplete
                                                                                                    v-model="addDepartmentID"
                                                                                                    :items="dropdowns.department_list"
                                                                                                    label="Department"
                                                                                                    class="mt-1"
                                                                                                    outlined
                                                                                                    auto-select-first
                                                                                                    dense
                                                                                                    required
                                                                                                ></v-autocomplete>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters>
                                                                                            <v-col cols="12">
                                                                                                <v-autocomplete
                                                                                                    v-model="addParticipantCompanyID"
                                                                                                    :items="dropdowns.company_list"
                                                                                                    item-text="name"
                                                                                                    item-value="id"
                                                                                                    label="Company"
                                                                                                    outlined
                                                                                                    auto-select-first
                                                                                                    dense
                                                                                                    required
                                                                                                ></v-autocomplete>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                            <v-col cols="12">
                                                                                                <v-autocomplete
                                                                                                    v-model="addParticipantBuffetNumber"
                                                                                                    :items="dropdowns.buffet_table_list"
                                                                                                    label="Buffet Table"
                                                                                                    class="mt-1"
                                                                                                    outlined
                                                                                                    auto-select-first
                                                                                                    dense
                                                                                                    required
                                                                                                ></v-autocomplete>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                            <v-autocomplete
                                                                                                v-model="addTenureCode"
                                                                                                :items="dropdowns.tenure_list"
                                                                                                label="Tenure Code"
                                                                                                class="mt-1"
                                                                                                outlined
                                                                                                auto-select-first
                                                                                                dense
                                                                                                required
                                                                                            ></v-autocomplete>
                                                                                        </v-row>
                                                                                        <v-row no-gutters>
                                                                                            <v-col cols="6">
                                                                                                <v-autocomplete 
                                                                                                    v-model="addParticipantGender" 
                                                                                                    :items="dropdowns.gender" 
                                                                                                    style="color:white;" 
                                                                                                    label="Gender"
                                                                                                    item-text="text" 
                                                                                                    item-value="value" 
                                                                                                    outlined
                                                                                                    dense
                                                                                                >
                                                                                                </v-autocomplete>
                                                                                            </v-col>
                                                                                            <v-col cols="6">
                                                                                                <v-text-field 
                                                                                                    v-model="addParticipantTableNumber"
                                                                                                    label="Table#" 
                                                                                                    class="ml-2"
                                                                                                    type="number"
                                                                                                    hide-spin-buttons
                                                                                                    outlined
                                                                                                    dense
                                                                                                >
                                                                                                </v-text-field>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                        <v-row no-gutters v-if="settings.include_raffle_grouping == 1">
                                                                                            <v-col cols="12">
                                                                                                <v-checkbox
                                                                                                    v-model="addParticipantIncludeRaffle"
                                                                                                    :true-value="1"
                                                                                                    :false-value="0"
                                                                                                    label="Include in Raffle"
                                                                                                    hide-spin-buttons
                                                                                                ></v-checkbox>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-container>
                                                                                </v-card-text>
                                                                                <v-divider :thickness="20"></v-divider>
                                                                                <div class="d-flex justify-content-center system_dialog_color">
                                                                                    <v-btn class="system_dialog_button_color" @click="addParticipant"  plain dark x-large :disabled="validateForm('add')">
                                                                                        Add
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>
                                                                        </v-card>
                                                                    </v-dialog>
                                                                </v-col>
        
                                                                <!-- Download Excel Button -->
                                                                <v-col cols="12" sm="4" lg="2" xl="2" class="d-flex justify-center">
                                                                    <v-dialog v-model="downloadParticipantsDialog" max-width="430">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn plain v-bind="attrs" v-on="on" class="underline-animation-black mt-2" style="font-size: 13px;">
                                                                        <v-icon size="24" color="#1976d2">mdi-cloud-download</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <!-- Download Dialog Content -->
                                                                    <v-card class="system_dialog_color system_admin_font_family_primary" style="font-size: smaller !important; overflow: hidden;">
                                                                        <v-card-title class="system_dialog_color" style="font-size: 24px; justify-content: center;">
                                                                        <span class="system_dialog_font_color">Guest Event Information</span>
                                                                        <v-icon size="44" left>mdi-microsoft-excel</v-icon>
                                                                        </v-card-title>
                                                                        <v-divider :thickness="50"></v-divider>
                                                                        <div class="pa-1 system_dialog_color" style="display: flex; justify-content: center;">
                                                                        <v-btn @click="downloadExcel" :loading="loading.guest_export" class="orange-border underline-animation-black system_dialog_button_color">
                                                                            <span class="system_dialog_font_color">
                                                                            <v-icon size="24" left>mdi-download-box</v-icon>
                                                                                Download excel file
                                                                            </span>
                                                                        </v-btn>
                                                                        </div>
                                                                    </v-card>
                                                                    </v-dialog>
                                                                </v-col>
        
                                                                <!-- Upload Excel Button -->
                                                                <v-col cols="12" sm="4" lg="2" xl="2" class="d-flex justify-center">
                                                                    <v-dialog v-model="uploadParticipantsDialog" max-width="70%" persistent>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn plain v-bind="attrs" v-on="on" class="underline-animation-black mt-2" style="font-size: 13px; height: 45px;">
                                                                        <v-icon size="24" color="#ffa500">mdi-cloud-upload</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <!-- Upload Dialog Content -->
                                                                    <v-card class="pa-5 system_dialog_color system_admin_font_family_primary" style="font-size: smaller !important; overflow: hidden;">
                                                                        <v-card-title class="pa-0 border-bottom system_dialog_color">
                                                                        <v-row class="m-0">
                                                                            <v-col cols="12" class="text-right p-2">
                                                                            <v-btn text icon small color="gray" @click="uploadParticipantsDialog = false">
                                                                                <v-icon>mdi-close-circle</v-icon>
                                                                            </v-btn>
                                                                            </v-col>
                                                                        </v-row>
                                                                        </v-card-title>
                                                                        <v-card-title style="font-size: 24px;">
                                                                        <v-row class="system_dialog_color">
                                                                            <v-spacer></v-spacer>
                                                                            <v-col class="text-center system_dialog_font_color" cols="4">
                                                                            Upload Guests
                                                                            <v-icon size="44" left>mdi-microsoft-excel</v-icon>
                                                                            </v-col>
                                                                            <v-col class="text-end" cols="4">
                                                                            <v-tooltip bottom color="blue">
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                <v-btn text icon color="blue" @click="downloadImportTemplate()" v-bind="attrs" v-on="on" large>
                                                                                    <v-icon color="blue">mdi-download-box</v-icon>
                                                                                </v-btn>
                                                                                </template>
                                                                                <span>Download Template</span>
                                                                            </v-tooltip>
                                                                            </v-col>
                                                                        </v-row>
                                                                        </v-card-title>
                                                                        <v-divider :thickness="50"></v-divider>
        
                                                                        <!-- Dropzone -->
                                                                        <v-row v-if="batchAdditionItems.length == 0 && loaded" @dragover="dragover" @dragleave="dragleave" @drop="drop" class="dropzone-container overflow-hidden system_dialog_color">
                                                                        <v-col cols="12" class="text-center">
                                                                            <v-icon style="font-size:50px;" :class="have_img?'d-none':'d-block'">mdi-upload</v-icon>
                                                                            <p :class="have_img?'d-none':'d-block'">
                                                                            Drag & Drop or 
                                                                            <label for="upload-file" style="color:blue;cursor:pointer;">browse</label>
                                                                            </p>
                                                                            <input type="file" id="upload-file" class="d-none" @change="ImportedExcel" ref="file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                                                        </v-col>
                                                                        </v-row>
        
                                                                        <!-- Loading -->
                                                                        <v-row v-if="!loaded">
                                                                        <v-col cols="12" class="text-center system_dialog_color">
                                                                            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                                                                            <p>{{ loading_text }}</p>
                                                                        </v-col>
                                                                        </v-row>
        
                                                                        <!-- Data Preview -->
                                                                        <v-row v-if="batchAdditionItems.length > 0">
                                                                        <v-col>
                                                                            <v-data-table
                                                                            :headers="import_guest_headers_filtered"
                                                                            fixed-header
                                                                            height="70vh"
                                                                            :items="batchAdditionItems"
                                                                            class="elevation-1"
                                                                            hide-default-footer
                                                                            :items-per-page="-1"
                                                                            ></v-data-table>
                                                                        </v-col>
                                                                        </v-row>
        
                                                                        <!-- Submit -->
                                                                        <v-card-actions>
                                                                        <v-row>
                                                                            <v-col cols="12" class="text-center" v-if="batchAdditionItems.length > 0">
                                                                            <v-btn color="#17468f" @click="submitImport()" :loading="loading.button">
                                                                                <span style="color:white;">submit</span>
                                                                            </v-btn>
                                                                            </v-col>
                                                                        </v-row>
                                                                        </v-card-actions>
                                                                    </v-card>
                                                                    </v-dialog>
                                                                </v-col>
                                                            </v-row>
        
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-btn :loading="loading.massPdf" @click="generatePDF(0, null, true)" class="system_admin_button_color ma-2 align-self-end">
                                                                        <v-icon>
                                                                            mdi-zip-box
                                                                        </v-icon>
                                                                        Mass Generate (By Company)
                                                                    </v-btn>
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-btn :loading="loading.massPdf" @click="generatePDF(0, null, 1, 1)" class="system_admin_button_color ma-2 align-self-end">
                                                                        <v-icon>
                                                                            mdi-file-pdf-box
                                                                        </v-icon>
                                                                        Mass Generate (By Guest)
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        
                                                        <v-col class="d-flex align-center">
                                                            <ReportsCardComponentVue :totals="totals" :cards="cards" style="width:100%;" class="ma-2"></ReportsCardComponentVue>
                                                            <!-- <ReportsCardComponentVue :totals="totalsCompany" :cards="cardsCompany" style="width:100%;" class="ma-2"></ReportsCardComponentVue> -->
                                                        </v-col>
        
                                                        <v-col cols="3" sm="3" lg="3" class=" system_admin_font_family_primary text-end">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="6" md="6" lg="6" class="pr-2">
                                                                    <v-text-field
                                                                        v-model="filterValue.guest_list_search_employee_id"
                                                                        label="Search Employee ID"
                                                                        prepend-icon="mdi-identifier"
                                                                        :hide-details="true"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="12" sm="6" md="6" lg="6" class="pl-2">
                                                                    <v-text-field
                                                                        v-model="filterValue.guest_list_search"
                                                                        label="Search Name"
                                                                        prepend-icon="mdi-text-search-variant"
                                                                        :hide-details="true"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-text-field
                                                                        v-model="filterValue.guest_list_search_table_search"
                                                                        label="Search Table #"
                                                                        prepend-icon="mdi-store-search-outline"
                                                                        :hide-details="true"
                                                                        class="mb-2"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>        
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-autocomplete
                                                                        v-model="filters.company_id"
                                                                        :items="dropdowns.company_list"
                                                                        :hide-details="true"
                                                                        @change="getTableData(0)"
                                                                        label="Company"
                                                                        item-text="name"
                                                                        item-value="id"
                                                                        clearable
                                                                        small-chips
                                                                        deletable-chips
                                                                        outlined
                                                                        auto-select-first
                                                                        multiple
                                                                        dense
                                                                        required
                                                                        class="system_admin_font_family_primary py-2"
                                                                    >
                                                                    </v-autocomplete>   
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-autocomplete
                                                                        v-model="filters.status"
                                                                        :items="dropdowns.status"
                                                                        @change="getTableData(0)"
                                                                        :hide-details="true"
                                                                        label="Status"
                                                                        item-text="text"
                                                                        item-value="value"
                                                                        outlined
                                                                        auto-select-first
                                                                        dense
                                                                        required
                                                                        class="system_admin_font_family_primary py-2"
                                                                    >
                                                                    </v-autocomplete>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>    
                                                    </v-row>
                                                </v-container>
                                            </template>
                                            <template v-slot:body="{ items }">
                                                <!-- <div v-if="loading.datatable" class="d-flex justify-center pa-5">
                                                    <span class="text-center" style="font-size: 12px; font-weight: bold; color: white;">
                                                        Loading, Please wait...
                                                    </span>
                                                </div> -->
                                                <tbody class="system_textdata_color ">
                                                    <tr v-for="(item, index) in items" :key="index">
                                                        <td>
                                                            <v-simple-checkbox
                                                                v-model="item.selected"
                                                                @input="addRemoveGuestToMassGenerate($event)"
                                                            ></v-simple-checkbox>
                                                        </td>
                                                        <td style="align-items: center;">{{ item.full_name }}</td>
                                                        <td v-if="settings.data_grouping == 1">{{ item.employee_id }}</td>
                                                        <td style="">{{ item.company_name }}</td>
                                                        <td style="">{{ item.unique_code }}</td>
                                                        <td class="text-center">{{ item.company_pax }}</td>
                                                        <td class="text-center">{{ item.table_num }}</td>
                                                        <td v-if="settings.data_grouping == 1">{{ item.tenure_code_name ? item.tenure_code_name : 'NONE' }}</td>
                                                        <td v-if="settings.data_grouping == 1">{{ item.buffet_meal_name ? item.buffet_meal_name : 'NONE' }}</td>
                                                        <!-- <td>{{ item.buffet_meal_id }}</td> -->
                                                        <!-- <td>{{ item.employment_duration_label }}</td> -->
                                                        <td class="text-center">{{ item.time_in }}</td>
                                                        <td class="text-center">
                                                            <v-btn @click="toggleStatus(item, 2)" text icon v-if="item.status_id == 1">
                                                                <v-icon :color="`grey`"> mdi-check-outline </v-icon>
                                                            </v-btn>
                                                            <v-btn @click="toggleStatus(item, 2)" text icon v-else>
                                                                <v-icon :color="`green`"> mdi-check-bold </v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td class="text-center">
                                                            <v-btn @click="toggleStatus(item, 1)" text icon v-if="item.status_id == 1">
                                                                <v-icon :color="`grey`"> mdi-minus-circle-outline </v-icon>
                                                            </v-btn>
                                                            <v-btn @click="toggleStatus(item, 1)" text icon v-else>
                                                                <v-icon :color="`red`"> mdi-minus-circle-outline </v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <!-- <td class="orange-text" style="font-family: Evogria;">{{ item.status_label }}</td> -->
                                                        <td class="text-center">
                                                            <v-btn
                                                                icon
                                                                @click="generatePDF(0, item)"
                                                            >
                                                                <v-icon>
                                                                    mdi-file-pdf-box
                                                                </v-icon>
                                                            </v-btn>
                                                            <v-dialog max-width="1000"  v-model="item.showDialog" persistent>
                                                                <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                                                                    <v-tooltip bottom color="#17468f">
                                                                        <template v-slot:activator="{ on:onTooltip, attrs: attrsTooltip }">
                                                                            <!-- <v-btn text icon color="#17468f"
                                                                                >
                                                                                <v-icon
                                                                                    @click="editRecord(item)"
                                                                                    color="#17468f"
                                                                                    class="btn-action"
                                                                                    small
                                                                                    >mdi-square-edit-outline</v-icon
                                                                                >
                                                                            </v-btn> -->
                                                                            <v-btn text icon color="blue" v-bind="{ ...attrsMenu, ...attrsTooltip}" v-on="{ ...onMenu, ...onTooltip }">
                                                                                <v-icon class="btn-action" small>mdi-square-edit-outline</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Edit Record</span>
                                                                    </v-tooltip>
                                                                    
                                                                    <v-btn text icon color="red" class="btn-action" small @click="deleteEmployee(item)">
                                                                        <v-icon color="red">mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-card  style=" font-size: smaller !important; overflow: hidden;" class="system_admin_font_family_primary">
                                                                    <v-card-title class="justify-content-center white--text system_dialog_color" style="font-size: 24px; ">
                                                                        <span class="system_dialog_font_color">Guest Information</span>
                                                                        <v-btn @click="closeDialog(item)" plain text icon color="red" class="align-start" style="left: 300px;">
                                                                            <span class="system_dialog_font_color"><v-icon class="btn-action">mdi-window-close</v-icon></span>
                                                                        </v-btn>
                                                                    </v-card-title>                      
                                                                    <v-divider :thickness="50" class="system_dialog_color"></v-divider>
                                                                    <v-card	 class="system_dialog_color system_admin_font_family_primary">
                                                                        <v-card-text class="system_dialog_color">
                                                                            <v-container class="system_dialog_color">
                                                                                <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                    <v-col cols="12">
                                                                                        <v-text-field 
                                                                                            v-model="item.employee_id" 
                                                                                            disabled 
                                                                                            color="#17468f"
                                                                                        >
                                                                                        </v-text-field>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters>
                                                                                    <v-col cols="4">
                                                                                        <v-text-field 
                                                                                            v-model="item.last_name" 
                                                                                            label="Last Name"
                                                                                            outlined 
                                                                                            dense
                                                                                        >
                                                                                        </v-text-field>
                                                                                    </v-col>
                                                                                    <v-col cols="4">
                                                                                        <v-text-field 
                                                                                            v-model="item.first_name" 
                                                                                            label="First Name"
                                                                                            class="ml-2"
                                                                                            outlined
                                                                                            dense
                                                                                        >
                                                                                        </v-text-field>
                                                                                    </v-col>
                                                                                    <v-col cols="4">
                                                                                        <v-text-field 
                                                                                            v-model="item.middle_name" 
                                                                                            label="Middle Name"
                                                                                            class="ml-2"
                                                                                            outlined
                                                                                            dense
                                                                                        >
                                                                                        </v-text-field>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                    <v-col cols="12">
                                                                                        <v-autocomplete
                                                                                            v-model="item.department_id"
                                                                                            :items="dropdowns.department_list"
                                                                                            label="Department"
                                                                                            color="#17468f"
                                                                                            class="mt-1"
                                                                                            outlined
                                                                                            auto-select-first
                                                                                            dense
                                                                                            required
                                                                                        ></v-autocomplete>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters>
                                                                                    <v-col cols="12">
                                                                                        <v-autocomplete
                                                                                            v-model="item.company_id"
                                                                                            :items="dropdowns.company_list"
                                                                                            item-text="name"
                                                                                            item-value="id"
                                                                                            label="Company"
                                                                                            outlined
                                                                                            auto-select-first
                                                                                            dense
                                                                                            required
                                                                                        ></v-autocomplete>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                    <v-col cols="12">
                                                                                        <v-autocomplete
                                                                                            v-model="item.buffet_meal_id"
                                                                                            :items="dropdowns.buffet_table_list"
                                                                                            label="Buffet Table"
                                                                                            outlined
                                                                                            auto-select-first
                                                                                            dense
                                                                                            required
                                                                                        ></v-autocomplete>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                    <v-col cols="12">
                                                                                        <v-autocomplete
                                                                                            v-model="item.tenure_code_id"
                                                                                            :items="dropdowns.tenure_list"
                                                                                            label="Tenure Code"
                                                                                            outlined
                                                                                            auto-select-first
                                                                                            dense
                                                                                            required
                                                                                        ></v-autocomplete>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters>
                                                                                    <v-col cols="6">
                                                                                        <v-autocomplete 
                                                                                            v-model="item.gender" 
                                                                                            :items="dropdowns.gender" 
                                                                                            style="color:white;" 
                                                                                            label="Gender"
                                                                                            item-value="value" 
                                                                                            item-text="text" 
                                                                                            outlined
                                                                                            dense
                                                                                        >
                                                                                        </v-autocomplete>
                                                                                    </v-col>
                                                                                    <v-col cols="6">
                                                                                        <v-text-field 
                                                                                            v-model="item.table_num"
                                                                                            type="number"
                                                                                            label="Table#"
                                                                                            class="ml-2"
                                                                                            hide-spin-buttons
                                                                                            outlined
                                                                                            dense
                                                                                        >
                                                                                        </v-text-field>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters>
                                                                                    <v-col cols="12">
                                                                                        <span>Unique Code: {{ item.unique_code }}</span>
                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters v-if="settings.data_grouping == 1">
                                                                                    <v-col cols="12">
                                                                                        <v-checkbox
                                                                                            v-model="item.include_raffle"
                                                                                            :true-value="1"
                                                                                            :false-value="0"
                                                                                            label="Include in Raffle"
                                                                                            hide-spin-buttons
                                                                                        ></v-checkbox>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-container>
                                                                        </v-card-text>
                                                                    <v-divider :thickness="20" class="system_dialog_color"></v-divider>
                                                                    <v-card-actions class="system_dialog_color system_admin_font_family_primar">
                                                                        <v-row>
                                                                            <v-col cols="12" class="text-center">
                                                                                <v-btn :disabled="validateForm('update', item)" class="system_dialog_button_color" @click="submitChanges(item)" plain dark x-large >
                                                                                    Save
                                                                                </v-btn>
                                                                            </v-col>	
                                                                        </v-row>
                                                                    </v-card-actions>
                                                                    </v-card>
                                                                </v-card>
                                                            </v-dialog>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                                    
                                    <!-- COMPANIES TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="company_headers"
                                            fixed-header
                                            height="70vh" 
                                            :items="company_items" 
                                            :search="filterValue.company_list"
                                            :loading="loading.datatable"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                            >
                                                <template v-slot:[`header.code`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                                </template>
                                                <template v-slot:[`header.name`]="{ header }">
                                                    <span class="system_tableheader_color">{{ header.text }}</span>
                                                </template>
                                                <template v-slot:[`header.action`]="{ header }">
                                                    <span class="system_tableheader_color">{{ header.text }}</span>
                                                </template>
                                                <template v-slot:top>
                                                    <v-container fluid class="system_admin_font_family_primary">
                                                        <v-row no-gutters>
                                                            <v-col cols="5" sm="5" lg="5" class="system_admin_font_family_primary">
                                                                <v-row no-gutters class="d-flex align-items-center">
                                                                    <v-col cols="12" sm="12" md="12" lg="12">
                                                                        <v-btn
                                                                            @click="dialogTrigger('Submit')"
                                                                            class="ml-1 mt-1 system_admin_button_color "
                                                                            >
                                                                                <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                            <span class="system_text_button_color">
                                                                                Add 
                                                                            </span></span>
                                                                        </v-btn>
                                                                        <v-dialog v-model="downloadCompanyDialog" max-width="440">
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-btn plain v-bind="attrs" v-on="on"  class="ml-2 mt-1 system_dialog_button_color orange-border underline-animation-black" 
                                                                                dark @mouseover="hovered = true" @mouseleave="hovered = false" 
                                                                                :class="{ 'orange-text': hovered }">
                                                                                    <span style="color:white; border: 2,solid,red;">Download Data </span>
                                                                                    <v-icon size="24" center color="white">
                                                                                        mdi-cloud-download
                                                                                    </v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-card class="system_admin_font_family_primary" style="font-size: smaller !important; overflow: hidden;">
                                                                                <v-card-title class="system_dialog_color" @mouseover="hovered = true" @mouseleave="hovered = false" :class="{ 'orange-text': hovered }" style="font-size: 24px; justify-content: center;">
                                                                                    Official Companies Information
                                                                                    <v-icon size="44" left>
                                                                                    mdi-microsoft-excel
                                                                                    </v-icon>
                                                                                </v-card-title>
                                                                                <v-divider :thickness="50"></v-divider>
                                                                                <div class="pa-1 system_dialog_color system_dialog_text_color" style="display: flex; justify-content: center;">
                                                                                    <v-btn @click="downloadCompaniesExcel" class="system_dialog_button_color orange-border underline-animation-black" dark @mouseover="hovered = true" @mouseleave="hovered = false" :class="{ 'orange-text': hovered }">
                                                                                    <span class="system_dialog_text_color">
                                                                                        <v-icon size="24" left>
                                                                                        mdi-download-box
                                                                                        </v-icon>
                                                                                        Download excel file
                                                                                    </span>
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>
                                                                        </v-dialog>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="12" md="12" lg="12">
                                                                        <v-btn @click="generatePDF(1)"
                                                                            :loading="loading.generatePDF"
                                                                            class="ml-1 mt-1 system_admin_button_color "
                                                                        >
                                                                            Generate PDF (By Company)
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-spacer></v-spacer>
                                                            <v-col cols="4" sm="4" lg="2" class="system_admin_font_family_primary">
                                                                <v-row no-gutters class="d-flex align-items-center">
                                                                    <v-col cols="12" sm="12" md="12" lg="12">
                                                                        <v-text-field
                                                                            v-model="filterValue.ticket_num"
                                                                            @focus="isTextFieldFocused = true"
                                                                            @blur="isTextFieldFocused = false"
                                                                            @click:clear="filterCompanyByTicket()"
                                                                            :class="{ 'base-color': isTextFieldFocused }"
                                                                            :hide-details="true"
                                                                            placeholder="Ticket#"
                                                                            prepend-icon="mdi-ticket-percent"
                                                                            class="my-page orange-text-field "
                                                                            color="#17468f"
                                                                            clearable
                                                                            autofocus
                                                                            flat
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="12" md="12" lg="12">
                                                                        <v-text-field
                                                                            v-model="filterValue.company_list"
                                                                            @focus="isTextFieldFocused = true"
                                                                            @blur="isTextFieldFocused = false"
                                                                            :class="{ 'base-color': isTextFieldFocused }"
                                                                            :hide-details="true"
                                                                            placeholder="Name"
                                                                            prepend-icon="mdi-text-search-variant"
                                                                            class="my-page orange-text-field "
                                                                            color="#17468f"
                                                                            clearable
                                                                            autofocus
                                                                            flat
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </template>	
                                                <template v-slot:[`item.code`]="{ item }">
                                                <span class="system_textdata_color">{{ item.code }}</span>
                                                </template>
                                                <template v-slot:[`item.name`]="{ item }">
                                                <span class="system_textdata_color">{{ item.name }}</span>
                                                </template>
                                                <template v-slot:item.image_path="{ item }">
                                                    <v-img class="img-thumbnail" width="50" height="50" :src="item.prize_image" eager contain></v-img>
                                                </template>
                                                <template v-slot:[`item.action`]="{item}">
                                                    <v-tooltip bottom color="#17468f">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn text icon color="#17468f"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                >
                                                                <v-icon
                                                                    @click="dialogTrigger('View', item)"
                                                                    color="#17468f"
                                                                    class="btn-action"
                                                                    small
                                                                    >mdi-eye</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span>View Record</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom color="#17468f">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn text icon color="#17468f"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                >
                                                                <v-icon
                                                                    @click="dialogTrigger('Update', item)"
                                                                    color="blue"
                                                                    class="btn-action"
                                                                    small
                                                                    >mdi-square-edit-outline</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span>Edit Record</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom color="red">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn text icon color="red"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                >
                                                                <v-icon
                                                                    class="btn-action"
                                                                    small
                                                                    @click="deleteRecord(item.id, 'companyRoute')"
                                                                    >mdi-delete</v-icon
                                                                >
                                                            </v-btn>
                                                        </template>
                                                        <span>Delete Record</span>
                                                    </v-tooltip>
                                                </template>
                                        </v-data-table>
                                    </v-tab-item>
                
                                    <!-- RAFFLE PRIZES TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            v-if="tab.index == 2"
                                            :headers="raffle_headers"
                                            :items="items" 
                                            :search="filterValue.raffle_prizes"
                                            :loading="loading.datatable"
                                            :server-items-length="totalItems" 
                                            :items-per-page="10"
                                            :options.sync="pagination"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table"  
                                            height="70vh"
                                            fixed-header
                                            @update:page="getTableData(2)"
                                            @update:items-per-page="getTableData(2)"
                                        >
                                                <!-- @update:page="handlePageChange" @update:items-per-page="handleItemsPerPageChange"-->
                                            <template v-slot:[`header.image_path`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.code`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.name`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.winner_count`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.order`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.tenure_codes`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.priority`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:top>
                                                <v-container fluid class="system_admin_font_family_primary">
                                                    <v-row no-gutters>
                                                        <v-col cols="10" sm="9" lg="10" class="system_admin_font_family_primary">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" class="d-flex flex-wrap align-center">
                                                                    <v-btn
                                                                        @click="dialogTrigger('Submit')"
                                                                        class="ml-1 mt-0 system_admin_button_color"
                                                                    >
                                                                        <span class="system_text_button_color">
                                                                            <v-icon class="system_text_button_color">mdi-plus</v-icon>
                                                                            Add
                                                                        </span>
                                                                    </v-btn>

                                                                    <v-btn
                                                                        @click="orderDialog(true)"
                                                                        class="ml-2 mt-0 system_admin_button_color"
                                                                    >
                                                                        <v-icon class="system_text_button_color">mdi-sort</v-icon>
                                                                        <span class="system_text_button_color">Order Prizes</span>
                                                                    </v-btn>

                                                                    <v-btn
                                                                        @click="downloadRafflePrize"
                                                                        class="ml-2 mt-0 system_dialog_button_color orange-border underline-animation-black"
                                                                        dark
                                                                        @mouseover="hovered = true"
                                                                        @mouseleave="hovered = false"
                                                                        :class="{ 'orange-text': hovered }"
                                                                    >
                                                                        <v-icon size="24" left>mdi-download-box</v-icon>
                                                                        <span class="system_dialog_text_color">Download Data</span>
                                                                    </v-btn>

                                                                    <v-dialog v-model="uploadRafflePrizesDialog" max-width="80%" persistent>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                class="ml-2 mt-0 system_admin_button_color"
                                                                            >
                                                                                <v-icon class="system_text_button_color">mdi-cloud-upload</v-icon>
                                                                                <span class="system_text_button_color">Import</span>
                                                                            </v-btn>
                                                                        </template>
                                                                        <!-- Upload Raffle Prizes Dialog Content -->
                                                                        <v-card class="pa-5 system_dialog_color system_admin_font_family_primary" style="font-size: smaller !important; overflow: hidden;">
                                                                            <v-card-title class="pa-0 border-bottom system_dialog_color">
                                                                                <v-row class="m-0">
                                                                                    <v-col cols="12" class="text-right p-2">
                                                                                        <v-btn text icon small color="gray" @click="uploadRafflePrizesDialog = false">
                                                                                            <v-icon>mdi-close-circle</v-icon>
                                                                                        </v-btn>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-card-title>
                                                                            <v-card-title style="font-size: 24px;">
                                                                                <v-row class="system_dialog_color">
                                                                                    <v-spacer></v-spacer>
                                                                                    <v-col class="text-center system_dialog_font_color" cols="4">
                                                                                        Upload Raffle Prizes
                                                                                        <v-icon size="44" left>mdi-microsoft-excel</v-icon>
                                                                                    </v-col>
                                                                                    <v-col class="text-end" cols="4">
                                                                                        <v-tooltip bottom color="blue">
                                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                                <v-btn text icon color="blue" @click="downloadRafflePrizeTemplate()" v-bind="attrs" v-on="on" large>
                                                                                                    <v-icon color="blue">mdi-download-box</v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Download Template</span>
                                                                                        </v-tooltip>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-card-title>
                                                                            <v-divider :thickness="50"></v-divider>

                                                                            <!-- Dropzone -->
                                                                            <v-row v-if="batchRafflePrizeItems.length == 0 && rafflePrizeLoaded" @dragover="rafflePrizeDragover" @dragleave="rafflePrizeDragleave" @drop="rafflePrizeDrop" class="dropzone-container overflow-hidden system_dialog_color">
                                                                                <v-col cols="12" class="text-center">
                                                                                    <v-icon style="font-size:50px;" :class="rafflePrizeHaveImg?'d-none':'d-block'">mdi-upload</v-icon>
                                                                                    <p :class="rafflePrizeHaveImg?'d-none':'d-block'">
                                                                                        Drag & Drop Excel file or 
                                                                                        <label for="upload-raffle-file" style="color:blue;cursor:pointer;">browse</label>
                                                                                    </p>
                                                                                    <input type="file" id="upload-raffle-file" class="d-none" @change="importRafflePrizeExcel" ref="rafflePrizeFile" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                                                                </v-col>
                                                                            </v-row>

                                                                            <!-- Loading -->
                                                                            <v-row v-if="!rafflePrizeLoaded">
                                                                                <v-col cols="12" class="text-center system_dialog_color">
                                                                                    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                                                                                    <p>{{ rafflePrizeLoadingText }}</p>
                                                                                </v-col>
                                                                            </v-row>

                                                                            <v-row
                                                                                v-if="batchRafflePrizeItems.length > 0"
                                                                                class="justify-end align-center mb-2"
                                                                            >
                                                                                <v-switch
                                                                                    v-model="uploadRafflePrizesFilterIncomplete"
                                                                                    :disabled="!hasIncompleteRaffleImport"
                                                                                    color="orange"
                                                                                    hide-details
                                                                                    inset
                                                                                    dense
                                                                                    class="mr-4"
                                                                                >
                                                                                    <template v-slot:label>
                                                                                        <span>Show only incomplete</span>
                                                                                    </template>
                                                                                </v-switch>
                                                                            </v-row>

                                                                            <!-- Data Preview -->
                                                                            <v-row v-if="batchRafflePrizeItems.length > 0">
                                                                                <v-col>
                                                                                    <v-data-table
                                                                                        :headers="import_raffle_prize_headers"
                                                                                        fixed-header
                                                                                        height="70vh"
                                                                                        :items="filteredRaffleImportItems"
                                                                                        class="elevation-1"
                                                                                        hide-default-footer
                                                                                        :items-per-page="-1"
                                                                                    >
                                                                                        <!-- IMAGE PATH -->
                                                                                        <template v-slot:[`item.image_path`]="{ item }">
                                                                                            <!-- Base64 image -->
                                                                                            <div 
                                                                                                v-if="item.image_base64" 
                                                                                                style="display: flex; align-items: center; justify-content: center;"
                                                                                            >
                                                                                                <v-img
                                                                                                    :src="item.image_base64"
                                                                                                    max-width="60"
                                                                                                    max-height="60"
                                                                                                    contain
                                                                                                    eager
                                                                                                    style="border-radius: 4px;"
                                                                                                ></v-img>
                                                                                            </div>

                                                                                            <!-- Normal image_path -->
                                                                                            <div
                                                                                                v-else-if="item.image_path && item.image_path.trim() !== '' && !item.image_path.toLowerCase().includes('paste image')"
                                                                                                style="display: flex; align-items: center;"
                                                                                            >
                                                                                                <v-icon small class="mr-1">mdi-image</v-icon>
                                                                                                <span class="system_textdata_color" style="font-size: 11px;">
                                                                                                    {{
                                                                                                        (item.image_path || '').length > 25
                                                                                                            ? item.image_path.substring(0, 25) + '...'
                                                                                                            : (item.image_path || '')
                                                                                                    }}
                                                                                                </span>
                                                                                            </div>

                                                                                            <!-- Embedded image -->
                                                                                            <div 
                                                                                                v-else-if="item.has_embedded_image"
                                                                                                style="display: flex; align-items: center;"
                                                                                            >
                                                                                                <v-icon small class="mr-1">mdi-image</v-icon>
                                                                                                <span class="system_textdata_color" style="font-size: 11px;">
                                                                                                    Embedded image detected
                                                                                                </span>
                                                                                            </div>

                                                                                            <!-- No image -->
                                                                                            <span v-else class="grey--text">No image</span>
                                                                                        </template>


                                                                                        <!-- CODE -->
                                                                                        <template v-slot:[`item.code`]="{ item }">
                                                                                            <div style="display: flex; align-items: center;">
                                                                                                <v-icon
                                                                                                    v-if="!item.code || item.code.trim() === ''"
                                                                                                    small color="error"
                                                                                                    class="mr-1"
                                                                                                >
                                                                                                    mdi-alert-circle
                                                                                                </v-icon>

                                                                                                <span :class="(!item.code || item.code.trim() === '') ? 'error--text font-weight-bold' : 'system_textdata_color'">
                                                                                                    {{ item.code || 'REQUIRED' }}
                                                                                                </span>
                                                                                            </div>
                                                                                        </template>


                                                                                        <!-- NAME -->
                                                                                        <template v-slot:[`item.name`]="{ item }">
                                                                                            <div style="display: flex; align-items: center;">
                                                                                                <v-icon
                                                                                                    v-if="!item.name || item.name.trim() === ''"
                                                                                                    small color="error"
                                                                                                    class="mr-1"
                                                                                                >
                                                                                                    mdi-alert-circle
                                                                                                </v-icon>

                                                                                                <span :class="(!item.name || item.name.trim() === '') ? 'error--text font-weight-bold' : 'system_textdata_color'">
                                                                                                    {{ item.name || 'REQUIRED' }}
                                                                                                </span>
                                                                                            </div>
                                                                                        </template>


                                                                                        <!-- TENURE CATEGORIES -->
                                                                                        <template v-slot:[`item.tenure_categories`]="{ item }">
                                                                                            <span class="system_textdata_color">
                                                                                                {{ item.tenure_categories || 'N/A' }}
                                                                                            </span>
                                                                                        </template>


                                                                                        <!-- WINNER COUNT -->
                                                                                        <template v-slot:[`item.winner_count`]="{ item }">
                                                                                            <span
                                                                                                :class="item.winner_count && (isNaN(item.winner_count) || item.winner_count < 1)
                                                                                                    ? 'error--text'
                                                                                                    : 'system_textdata_color'"
                                                                                            >
                                                                                                {{ item.winner_count || 1 }}
                                                                                            </span>
                                                                                        </template>


                                                                                        <!-- ORDER -->
                                                                                        <template v-slot:[`item.order`]="{ item }">
                                                                                            <span
                                                                                                :class="item.order && (isNaN(item.order) || item.order < 1)
                                                                                                    ? 'error--text'
                                                                                                    : 'system_textdata_color'"
                                                                                            >
                                                                                                {{ item.order || 'N/A' }}
                                                                                            </span>
                                                                                        </template>


                                                                                        <!-- BATCH -->
                                                                                        <template v-slot:[`item.batch`]="{ item }">
                                                                                            <span
                                                                                                :class="item.batch && (isNaN(item.batch) || item.batch < 1)
                                                                                                    ? 'error--text'
                                                                                                    : 'system_textdata_color'"
                                                                                            >
                                                                                                {{ item.batch || 1 }}
                                                                                            </span>
                                                                                        </template>


                                                                                        <!-- SUSPENSE ANIMATE -->
                                                                                        <template v-slot:[`item.suspense_animate`]="{ item }">
                                                                                            <v-chip
                                                                                                x-small
                                                                                                :color="item.suspense_animate == 1 ? 'success' : 'grey'"
                                                                                            >
                                                                                                {{ item.suspense_animate == 1 ? 'Yes' : 'No' }}
                                                                                            </v-chip>
                                                                                        </template>

                                                                                    </v-data-table>
                                                                                </v-col>
                                                                            </v-row>

                                                                            <!-- Submit -->
                                                                            <v-card-actions>
                                                                                <v-row>
                                                                                    <v-col cols="12" class="text-center" v-if="batchRafflePrizeItems.length > 0">
                                                                                        <v-btn
                                                                                            color="#17468f"
                                                                                            @click="submitRafflePrizeImport()"
                                                                                            :loading="loading.button"
                                                                                            :disabled="hasIncompleteRaffleImport || !batchRafflePrizeItems.length || loading.button"
                                                                                        >
                                                                                            <span style="color:white;">Submit</span>
                                                                                        </v-btn>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-card-actions>
                                                                        </v-card>
                                                                    </v-dialog>

                                                                    <v-btn
                                                                        @click="raffleGroupDialogTrigger(true)"
                                                                        class="ml-2 mt-0 system_admin_button_color"
                                                                    >
                                                                        <v-icon class="system_text_button_color">mdi-format-list-group</v-icon>
                                                                        <span class="system_text_button_color">Raffle Group</span>
                                                                    </v-btn>

                                                                    <!-- Priority Switch (now in same row) -->
                                                                    <v-switch
                                                                        v-model="filterPriority"
                                                                        label="Priority"
                                                                        color="primary"
                                                                        dense
                                                                        hide-details
                                                                        class="ml-4 mt-0"
                                                                        @change="getTableData(2)"
                                                                    />                                                            
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="2" sm="3" lg="2" class="system_admin_font_family_primary">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12" class="mb-2">
                                                                    <v-text-field
                                                                        v-model="filterValue.raffle_prizes"
                                                                        @focus="isTextFieldFocused = true"
                                                                        @blur="isTextFieldFocused = false"
                                                                        label="Name"
                                                                        prepend-icon="mdi-text-search-variant"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                        @keypress.enter="getTableData(2)"
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </template>
                                            <v-divider :thickness="50"></v-divider>
                                            <!-- put a v-container on here  -->
                                            <template v-slot:[`item.code`]="{ item }">
                                            <span class="system_textdata_color">{{ item.code }}</span>
                                            </template>
                                            <template v-slot:[`item.name`]="{ item }">
                                            <span class="system_textdata_color">{{ item.name }}</span>
                                            </template>
                                            <template v-slot:[`item.winner_count`]="{ item }">
                                            <span class="system_textdata_color">{{ item.winner_count }}</span>
                                            </template>
                                            <template v-slot:[`item.order`]="{ item }">
                                            <span class="system_textdata_color">{{ item.order }}</span>
                                            </template>
                                            <template v-slot:[`item.priority`]="{ item }">
                                                <v-chip
                                                    v-if="item.priority == 1 || item.priority === true"
                                                    x-small
                                                    color="primary"
                                                >
                                                    Priority
                                                </v-chip>
                                                <span v-else class="system_textdata_color">-</span>
                                            </template>
                                            <template v-slot:item.image_path="{ item }">
                                                <v-img class="img-thumbnail" width="50" height="50" :src="checkImagePath(item.image_path)" eager contain></v-img>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'rafflePrizes')"
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                        <!-- Raffle Prize Order Dialog -->
                                        <v-dialog v-model="orderPrizeDialog" width="70%" persistent max-width="1200" scrollable>
                                            <v-card class="system_admin_font_family_primary raffle-order-dialog-card" style="max-height: 90vh; display: flex; flex-direction: column;">
                                                <v-card-title class="pa-4 pb-3 border-bottom system_dialog_color system_admin_font_family_primary" style="flex-shrink: 0;">
                                                    <v-row class="m-0 align-center" no-gutters>
                                                        <v-col cols="11" class="pa-0">
                                                            <span class="h5 system_dialog_font_color system_admin_font_family_primary" style="font-weight: 600;">Raffle Prizes Order</span>
                                                        </v-col>
                                                        <v-col cols="1" class="pa-0 text-right">
                                                            <v-btn
                                                                text
                                                                icon
                                                                small
                                                                color="gray"
                                                                @click="orderDialog(false)"
                                                            >
                                                                <v-icon class="system_dialog_font_color">mdi-close-circle</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text class="system_dialog_color system_admin_font_family_primary pa-0" style="flex: 1 1 auto; overflow-y: auto; overflow-x: hidden;">
                                                    <v-container class="pa-4 system_dialog_color" fluid>
                                                        <!-- Priority Raffle Section -->
                                                        <v-row class="mb-4">
                                                            <v-col cols="12">
                                                                <v-card outlined class="priority-raffle-card" style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                                                                    <v-card-title class="pa-3 pb-2" style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%); border-radius: 8px 8px 0 0;">
                                                                        <v-icon color="white" class="mr-2">mdi-star</v-icon>
                                                                        <span class="h6 white--text" style="font-weight: 600;">Priority Draw</span>
                                                                    </v-card-title>
                                                                    <v-card-text class="pa-4">
                                                                        <v-autocomplete
                                                                            v-model="priorityRafflePrizes"
                                                                            :items="availableRafflePrizes"
                                                                            item-text="name"
                                                                            item-value="id"
                                                                            label="Select Priority Raffles"
                                                                            multiple
                                                                            chips
                                                                            deletable-chips
                                                                            outlined
                                                                            dense
                                                                            class="system_dialog_text_color mb-3"
                                                                            :item-disabled="isRaffleDrawn"
                                                                            @change="onPriorityRafflesChange"
                                                                        >
                                                                            <template v-slot:selection="{ item, index }">
                                                                                <v-chip
                                                                                    v-if="index < 2"
                                                                                    small
                                                                                    color="primary"
                                                                                    class="ma-1"
                                                                                    close
                                                                                >
                                                                                    {{ item.name }}
                                                                                </v-chip>
                                                                                <span
                                                                                    v-else-if="index === 2"
                                                                                    class="grey--text caption ml-2"
                                                                                >
                                                                                    (+{{ priorityRafflePrizes.length - 2 }} others)
                                                                                </span>
                                                                            </template>
                                                                            <template v-slot:item="{ item }">
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title :class="item.raffle_drawn == 1 ? 'text--disabled' : ''">
                                                                                        {{ item.name }}
                                                                                    </v-list-item-title>
                                                                                    <v-list-item-subtitle v-if="item.raffle_drawn == 1" class="text--disabled">
                                                                                        Already drawn - cannot be selected
                                                                                    </v-list-item-subtitle>
                                                                                </v-list-item-content>
                                                                            </template>
                                                                        </v-autocomplete>
                                                                        <v-alert
                                                                            v-if="priorityRafflePrizes.length > 0"
                                                                            type="info"
                                                                            dense
                                                                            class="mt-2 mb-3"
                                                                            style="border-radius: 4px;"
                                                                        >
                                                                            {{ priorityRafflePrizes.length }} raffle(s) marked as priority. These will be drawn first.
                                                                        </v-alert>
                                                                        <!-- Priority Raffles Data Table -->
                                                                        <div v-if="priorityRafflePrizes.length > 0" class="priority-table-container" style="max-height: 300px; overflow-y: auto; border-radius: 4px; border: 1px solid rgba(255,255,255,0.1);">
                                                                            <v-data-table
                                                                                :headers="priorityRaffleHeaders"
                                                                                :items="selectedPriorityRaffles"
                                                                                :items-per-page="10"
                                                                                class="system_dialog_color priority-table"
                                                                                dense
                                                                                hide-default-footer
                                                                                item-key="id"
                                                                            >
                                                                                <template v-slot:body>
                                                                                    <draggable
                                                                                        v-model="selectedPriorityRaffles"
                                                                                        tag="tbody"
                                                                                        :move="checkPriorityMove"
                                                                                        @end="updatePriorityOrder"
                                                                                    >
                                                                                        <tr
                                                                                            v-for="(item, index) in selectedPriorityRaffles"
                                                                                            :key="item.id"
                                                                                            :style="getPriorityTableRowStyle(item)"
                                                                                            class="system_dialog_font_color"
                                                                                        >
                                                                                            <td class="system_textdata_color text-center">{{ item.priority_order || index + 1 }}</td>
                                                                                            <td class="system_textdata_color">{{ item.code }}</td>
                                                                                            <td class="system_textdata_color">{{ item.name }}</td>
                                                                                            <td class="system_textdata_color">{{ item.raffle_group_name || 'N/A' }}</td>
                                                                                            <td class="system_textdata_color text-center">
                                                                                                <v-chip
                                                                                                    v-if="item.raffle_drawn == 1"
                                                                                                    x-small
                                                                                                    color="success"
                                                                                >
                                                                                                    Yes
                                                                                                </v-chip>
                                                                                                <span v-else class="system_textdata_color">No</span>
                                                                                            </td>
                                                                                            <td class="system_textdata_color text-center">
                                                                                                <v-btn
                                                                                                    icon
                                                                                                    x-small
                                                                                                    color="error"
                                                                                                    :disabled="item.raffle_drawn == 1"
                                                                                                    @click="removePriorityRaffle(item.id)"
                                                                                                >
                                                                                                    <v-icon small>mdi-delete</v-icon>
                                                                                                </v-btn>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </draggable>
                                                                                </template>
                                                                            </v-data-table>
                                                                        </div>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                        <!-- Normal Raffle Prizes Section -->
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-card outlined class="normal-raffle-card" style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                                                                    <v-card-title class="pa-3 pb-2" style="background: linear-gradient(135deg, #424242 0%, #212121 100%); border-radius: 8px 8px 0 0;">
                                                                        <v-icon color="white" class="mr-2">mdi-format-list-bulleted</v-icon>
                                                                        <span class="h6 white--text" style="font-weight: 600;">Normal Draw</span>
                                                                    </v-card-title>
                                                                    <v-card-text class="pa-0">
                                                                        <div class="normal-table-container" style="max-height: 400px; overflow-y: auto; border-radius: 0 0 8px 8px;">
                                                                            <v-simple-table class="table table-striped system_dialog_color" dense>
                                                                                <thead class="system_tableheader_color system_admin_font_family_primary" style="position: sticky; top: 0; z-index: 10;">
                                                                                    <tr class="system_tableheader_color">
                                                                                        <th scope="col" class="system_tableheader_color text-center" style="width: 10%;">Order</th>
                                                                                        <th scope="col" class="system_tableheader_color text-left" style="width: 15%;">Code</th>
                                                                                        <th scope="col" class="system_tableheader_color" style="width: 30%;">Name</th>
                                                                                        <th scope="col" class="system_tableheader_color" style="width: 20%;">Raffle Group</th>
                                                                                        <th scope="col" class="system_tableheader_color text-center" style="width: 15%;">Raffle Drawn</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <draggable 
                                                                                    v-model="nonPriorityRaffleItems" 
                                                                                    tag="tbody"
                                                                                    :disabled="false"
                                                                                    :move="checkMove"
                                                                                >
                                                                                    <tr 
                                                                                        v-for="(item, index) in nonPriorityRaffleItems" 
                                                                                        :key="item.id || item.title" 
                                                                                        :style="getTableRowStyle(item)" 
                                                                                        class="system_dialog_font_color table-row-hover"
                                                                                    >
                                                                                        <td class="system_textdata_color text-center font-weight-bold">{{ index + 1 }}</td>
                                                                                        <td class="system_textdata_color text-center">{{ item.code }}</td>
                                                                                        <td class="system_textdata_color">{{ item.name }}</td>
                                                                                        <td class="system_textdata_color">{{ item.raffle_group_name || 'N/A' }}</td>
                                                                                        <td class="system_textdata_color text-center">
                                                                                            <v-chip
                                                                                                v-if="item.raffle_drawn == 1"
                                                                                                x-small
                                                                                                color="success"
                                                                                            >
                                                                                                Yes
                                                                                            </v-chip>
                                                                                            <span v-else class="system_textdata_color">No</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </draggable>
                                                                            </v-simple-table>
                                                                        </div>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions
                                                    class="text-center system_dialog_color pa-4"
                                                    style="border-top: 1px solid rgba(255,255,255,0.1); flex-shrink: 0;"
                                                >
                                                    <v-col cols="12" class="pa-0">
                                                        <v-btn
                                                            @click="saveOrder()"
                                                            class="system_dialog_button_color"
                                                            large
                                                            style="min-width: 120px;"
                                                        >
                                                            <v-icon left>mdi-content-save</v-icon>
                                                            <span class="system_dialog_font_color"> Save </span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
            
                                        <!-- Raffle Group Dialog -->
                                        <v-dialog v-model="raffleGroupDialog" width="40%" persistent class="">
                                            <v-card class="overflow-x-hidden overflow-y-auto system_admin_font_family_primary" >
                                                <v-card-title class="pa-3 pl-3 pb-0 border-bottom system_dialog_color system_admin_font_family_primary">
                                                    <span class=" h5 system_dialog_font_color system_admin_font_family_primary">Raffle Groups</span>
                                                    <v-row class="m-0">
                                                        <v-col cols="pull-right-10 p-2">
                                                            <v-btn
                                                                text
                                                                icon
                                                                small
                                                                color="gray"
                                                                class="float-right"
                                                                @click="raffleGroupDialogTrigger(false)"
                                                            >
                                                                <span class="system_dialog_font_color"><v-icon>mdi-close-circle</v-icon></span>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text class="py-2">
                                                    <v-row>
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="12" sm="4" md="4" lg="4" class="text-end">
                                                            <v-btn
                                                                fab
                                                                dark
                                                                small
                                                                color="primary"
                                                                style="height: 20px; width: 20px"
                                                                @click="addRaffleGroupItem()"
                                                                :disabled="disabled_view"
                                                                >
                                                                <v-icon dark small style="font-size: 12px">mdi-plus</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <!-- <v-spacer></v-spacer>
                                                        <v-col cols="12" sm="4" md="4" lg="4" class="text-end">
                                                            <v-btn
                                                                @click="getAllTableData()"
                                                            >
                                                                filter
                                                            </v-btn>
                                                        </v-col> -->
                                                    </v-row>
                                                    <v-row v-for="(item,index) in raffle_groups"  :key="index">
                                                        <v-col cols="5">
                                                            <v-text-field 
                                                                label="Code"
                                                                v-model="item.code" 
                                                                outlined 
                                                                hide-details 
                                                                dense
                                                            >
                                                            </v-text-field>
                                                        </v-col>
                                                        <v-col cols="5">
                                                            <v-text-field 
                                                                label="Name"
                                                                v-model="item.name" 
                                                                outlined 
                                                                hide-details 
                                                                dense
                                                            >
                                                            </v-text-field>
                                                        </v-col>
                                                        <v-col cols="1" class="text-center">
                                                            <v-btn
                                                                @click="raffle_groups.splice(index, 1)"
                                                                color="red"
                                                                small
                                                                text
                                                                icon
                                                            >
                                                                <v-icon>mdi-minus-circle</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                                <v-card-actions
                                                    class="text-center system_dialog_color"
                                                    style="border-top: 1px solid #000000"
                                                >
                                                    <v-col cols="12">
                                                        <v-btn
                                                            @click="upsertRaffleGroup()"
                                                            class="system_dialog_button_color"
                                                        >
                                                            <span class="system_dialog_font_color"> Save </span>
                                                        </v-btn>
                                                        <span class="pr-12">&nbsp;</span>
                                                    </v-col>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-tab-item>
                                    
                                    <!-- ACTIVITIES TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            v-if="tab.index == 3"
                                            :headers="activities_headers" 
                                            :items="items" 
                                            :search="filterValue.activities"
                                            :loading="loading.datatable"
                                            :server-items-length="totalItems"
                                            :items-per-page="10"
                                            :options.sync="pagination"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                            @update:page="getTableData(3)"
                                            @update:items-per-page="getTableData(3)"
                                        >
                                            <template v-slot:[`header.name`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.description`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:top>
                                                <v-container fluid class="system_admin_font_family_primary">
                                                    <v-row no-gutters>
                                                        <v-col cols="6" sm="6" lg="6" class="system_admin_font_family_primary text-end">
                                                            <v-row no-gutters>
                                                                <v-col cols="3" sm="3" md="3" lg="12" class="text-start">
                                                                    <v-btn
                                                                        @click="dialogTrigger('Submit')"
                                                                        class="ml-1 mt-1 system_admin_button_color"
                                                                    >
                                                                        <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                            <span class="system_text_button_color">
                                                                                Add
                                                                            </span>
                                                                        </span>
                                                                    </v-btn>
                                                                </v-col>
                                                                <v-spacer></v-spacer>
                                                            </v-row>
                                                        </v-col> 
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="6" sm="6" lg="6" class="system_admin_font_family_primary text-end">
                                                            <v-row no-gutters>
                                                                <v-spacer></v-spacer>
                                                                <v-col cols="8" sm="8" md="8" lg="4">
                                                                    <v-text-field
                                                                        v-model="filterValue.activities"
                                                                        @focus="isTextFieldFocused = true"
                                                                        @blur="isTextFieldFocused = false"
                                                                        :class="{ 'base-color': isTextFieldFocused }"
                                                                        prepend-icon="mdi-text-search-variant"
                                                                        class="my-page orange-text-field"
                                                                        color="#17468f"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col> 
                                                    </v-row>
                                                </v-container>  
                                            </template>
                                            <template v-slot:[`item.name`]="{ item }">
                                                <span class="system_textdata_color">{{ item.name }}</span>
                                            </template>
                                            <template v-slot:[`item.description`]="{ item }">
                                                <span class="system_textdata_color">{{ item.description }}</span>
                                            </template>
                                            <template v-slot:item.image_path="{ item }">
                                                <v-img class="img-thumbnail" width="50" height="50" :src="checkImagePath(item.image_path)" eager contain></v-img>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'eventActivities')"
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                
                                    <!-- PROGRAM FLOW TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="program_flow_headers" 
                                            :items="items" 
                                            :search="filterValue.program_flow"
                                            :loading="loading.datatable"
                                            :server-items-length="pagination.totalItems"
                                            :options.sync="pagination"
                                            @update:options="onPaginationChange"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                        >
                                            <template v-slot:[`header.image_path`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.order`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:top>
                                                <v-container fluid class="system_admin_font_family_primary">
                                                    <v-row no-gutters>
                                                        <v-col cols="9" sm="9" lg="3" class="system_admin_font_family_primary">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-btn
                                                                        @click="dialogTrigger('Submit')"
                                                                        
                                                                        class="ml-1 mt-1 system_admin_button_color"
                                                                        >
                                                                        <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                        <span class="system_text_button_color">
                                                                            Add 
                                                                        </span></span>
                                                                    </v-btn>
                                                                    <v-btn
                                                                        @click="flowDialogTrigger(true)"
                                                                        
                                                                        class="ml-2 mt-1 system_admin_button_color"
                                                                        >
                                                                        <span><v-icon class="system_text_button_color"> mdi-sort</v-icon>
                                                                        <span class="system_text_button_color">
                                                                            Order Program Flow
                                                                        </span></span>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        <v-col cols="3" sm="3" lg="3" class=" system_admin_font_family_primary text-end">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-text-field
                                                                        v-model="filterValue.program_flow"
                                                                        @focus="isTextFieldFocused = true"
                                                                        @blur="isTextFieldFocused = false"
                                                                        prepend-icon="mdi-text-search-variant"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>   
                                                    </v-row>
                                                </v-container>
                                                <div class="" style="padding:0px; font-family: Evogria;">
                                                    <v-row>
                                                        <!-- <v-col cols="1">
                                                            <v-dialog v-model="downloadParticipantsDialog" max-width="430">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn plain v-bind="attrs" v-on="on" class="underline-animation-black mt-2" style="font-size: 13px; height: 45px;">
                                                                        <span style="font-family: Evogria; color:#17468f;">Download Data </span>
                                                                        <v-icon size="24" center color="#17468f">
                                                                            mdi-cloud-download
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-card style="font-family: Evogria; font-size: smaller !important; overflow: hidden; background-color: black;">
                                                                    <v-card-title @mouseover="hovered = true" @mouseleave="hovered = false" :class="{ 'orange-text': hovered }" style="font-size: 24px; justify-content: center;">
                                                                        Guests Event Information
                                                                        <v-icon size="44" left>
                                                                        mdi-microsoft-excel
                                                                        </v-icon>
                                                                    </v-card-title>
                                                                    <v-divider :thickness="50"></v-divider>
                                                                    <div class="pa-1" style="display: flex; justify-content: center;">
                                                                        <v-btn @click="downloadExcel" class="orange-border underline-animation-black" color="#17468f" dark @mouseover="hovered = true" @mouseleave="hovered = false" :class="{ 'orange-text': hovered }">
                                                                            <span style="color: black;">
                                                                                <v-icon size="24" left>
                                                                                mdi-download-box
                                                                                </v-icon>
                                                                                Download excel file
                                                                            </span>
                                                                        </v-btn>
                                                                    </div>
                                                                </v-card>
                                                            </v-dialog>
                                                        </v-col> -->
                                                        <v-col cols="2" class="system_admin_font_family_primary">
                                                        
                                                        </v-col>                  
                                                    </v-row>
                                                </div>
                                            </template>
                                            <template v-slot:[`item.order`]="{ item }">
                                            <span class="system_textdata_color">{{ item.order }}</span>
                                            </template>
                                            <template v-slot:item.image_path="{ item }">
                                                <v-img class="img-thumbnail" width="50" height="50" :src="item.flow_image" eager contain></v-img>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'programFlowImage')"
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                        <v-dialog v-model="flowDialog" width="50%" persistent  class="pt-0 mt-0	" height="700">
                                            <v-card class="overflow-x-hidden overflow-y-auto"  >
                                                <v-card-title class="pa-3 pl-3 pb-0 border-bottom system_dialog_color system_admin_font_family_primary">
                                                    <span class="h5 system_dialog_font_color"> Program Flow Images Order</span>
                                                    <v-row class="m-0">
                                                        <v-col cols="pull-right-10 p-2">
                                                            <v-btn
                                                                text
                                                                icon
                                                                small
                                                                color="gray"
                                                                class="float-right"
                                                                @click="flowDialogTrigger(false)"
                                                            >
                                                                <span class="system_dialog_font_color"><v-icon>mdi-close-circle</v-icon></span>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text class="system_dialog_color">
                                                    <v-container class="pb-0 mt-1 overflow-auto" fluid>
                                                        <v-simple-table class="table table-striped system_table_color system_admin_font_family_primary" height="700" width="200">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Image</th>
                                                                    <th scope="col">Order</th>
                                                                </tr>
                                                            </thead>
                                                            <draggable v-model="draggable_items" tag="tbody" >
                                                                <tr v-for="(item, index) in draggable_items" :key="item.title" :style="tableRowStyle(item.title)">
                                                                    <td> <v-img class="img-thumbnail" width="50" height="50" :src="item.flow_image" eager contain></v-img> </td>
                                                                    <td>{{ index + 1 }}</td>
                                                                </tr>
                                                            </draggable>
                                                            </v-simple-table>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions
                                                    class="text-center system_dialog_color system_admin_font_family_primary"
                                                    style="border-top: 1px solid #000000"
                                                >
                                                    <v-col cols="12">
                                                        <v-btn
                                                            @click="saveFlowOrder()"
                                                            class="system_dialog_button_color"
                                                        >
                                                            <span> Save </span>
                                                        </v-btn>
                                                        <span class="pr-12">&nbsp;</span>
                                                    </v-col>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-tab-item>
                
                                    <!-- EVENT NOMINEES TAB -->
                                    <v-tab-item>
                                        <v-tabs v-model="n_tab" class="system_sub_admin_toolbar_color">
                                            <v-tabs-slider class="system_sub_admin_toolbar_color"></v-tabs-slider>
                                            <v-tab
                                                v-for="(nominee_tab, i) in nominee_tabs"
                                                :key="i"
                                                @click="changeNomineeTab(nominee_tab.gender)"
                                                class="system_sub_admin_toolbar_color system_admin_font_family_primary flexible-table"
                                            >
                                                <v-icon>{{ nominee_tab.icon }}</v-icon>
                                                <span style="color: white;">{{ nominee_tab.text }}</span>
                                            </v-tab>
                                            <v-spacer class="system_sub_admin_toolbar_color"></v-spacer>
                                        </v-tabs>
                                        
                                        <v-tabs-items v-model="n_tab">
                                            <v-tab-item
                                                v-for="(nominee_tab, i) in nominee_tabs"
                                                :key="i"
                                            >
                                                <v-data-table
                                                    :headers="event_nominee_headers"
                                                    :items="items"
                                                    :search="filterValue.event_nominees"
                                                    :loading="loading.datatable"
                                                    :sort-by="'vote_count'"
                                                    :sort-desc="['vote_count']"
                                                    :server-items-length="pagination.totalItems"
                                                    :options.sync="pagination"
                                                    @update:options="onPaginationChange"
                                                    class="elevation-1 orange-border system_admin_table_color"
                                                    style="background-color: black;"
                                                >
                                                    <template v-slot:[`header.full_name`]="{ header }">
                                                        <span class="system_tableheader_color">{{ header.text }}</span>
                                                    </template>
                                                    <template v-slot:[`header.company_name`]="{ header }">
                                                        <span class="system_tableheader_color">{{ header.text }}</span>
                                                    </template>
                                                    <template v-slot:[`header.vote_count`]="{ header }">
                                                        <span class="system_tableheader_color">{{ header.text }}</span>
                                                    </template>
                                                    <template v-slot:[`header.action`]="{ header }">
                                                        <span class="system_tableheader_color">{{ header.text }}</span>
                                                    </template>
                
                                                    <template v-slot:top>
                                                        <div class="system_admin_font_family_primary" style="padding: 0px; font-family: Evogria;">
                                                            <v-row>
                                                                <v-col cols="2">
                                                                    <v-btn @click="dialogTrigger('Submit')" class="ml-1 mt-2 system_admin_button_color">
                                                                        <span class="system_text_button_color">
                                                                            <v-icon class="system_text_button_color">mdi-plus</v-icon>
                                                                            <span class="system_text_button_color">Add</span>
                                                                        </span>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </div>
                                                    </template>
                
                                                    <template v-slot:item.action="{ item }">
                                                        <v-tooltip bottom color="#17468f">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn text icon color="#17468f" v-bind="attrs" v-on="on">
                                                                    <v-icon @click="dialogTrigger('Update', item, 1)" color="blue" class="btn-action" small>
                                                                        mdi-square-edit-outline
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Edit Record</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom color="red">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn text icon color="red" v-bind="attrs" v-on="on">
                                                                    <v-icon @click="deleteNominee(item)" color="red" class="btn-action" small>
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Delete Nominee</span>
                                                        </v-tooltip>
                                                    </template>
                                                </v-data-table>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-tab-item>
                
                                    <!-- EVENT SITEMAP TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="event_sitemap_headers" 
                                            :items="items" 
                                            :search="filterValue.event_sitemap"
                                            :loading="loading.datatable"
                                            :server-items-length="pagination.totalItems"
                                            :options.sync="pagination"
                                            @update:options="onPaginationChange"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                        >
                                            <template v-slot:[`header.image_path`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.order`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:top>
                                                <v-container fluid class="system_admin_font_family_primary">
                                                    <v-row no-gutters>
                                                        <v-col cols="4" sm="4" lg="3" class="system_admin_font_family_primary">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-btn
                                                                        @click="dialogTrigger('Submit')"
                                                                        class="ml-1 mt-1 system_admin_button_color"
                                                                        >
                                                                        <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                        <span class="system_text_button_color">
                                                                            Add
                                                                        </span></span>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col> 
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="4" sm="4" lg="3" class="system_admin_font_family_primary">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                                    <v-text-field
                                                                        v-model="filterValue.event_sitemap"
                                                                        @focus="isTextFieldFocused = true"
                                                                        @blur="isTextFieldFocused = false"
                                                                        :class="{ 'base-color': isTextFieldFocused }"
                                                                        prepend-icon="mdi-text-search-variant"
                                                                        class="my-page orange-text-field"
                                                                        color="#17468f"
                                                                        clearable
                                                                        autofocus
                                                                        flat
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col> 
                                                    </v-row>
                                                </v-container>
                                            </template>
                                            <template v-slot:[`item.order`]="{ item }">
                                                <span class="system_textdata_color">{{ item.order }}</span>
                                            </template>
                                            <template v-slot:item.image_path="{ item }">
                                                <v-img class="img-thumbnail" width="50" height="50" :src="item.sitemap_image" eager contain></v-img>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'eventSitemap')"
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                
                                    <!-- EVENT DETAILS TAB -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="event_details_headers" 
                                            :items="items" 
                                            :search="filterValue.event_sitemap"
                                            :server-items-length="pagination.totalItems"
                                            :options.sync="pagination"
                                            @update:options="onPaginationChange"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                        >
                                            <template v-slot:[`header.code`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.name`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.link`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                        
                                            <template v-slot:top>
                                                <div class="system_admin_font_family_primary" style="padding:0px;">
                                                    <v-row>
                                                        
                                                        <v-col cols="2">
                                                            <v-btn
                                                                @click="dialogTrigger('Submit')"
                                                                
                                                                class="ml-1 mt-1 system_admin_button_color"
                                                                >
                                                                <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                <span class="system_text_button_color">
                                                                    Add
                                                                </span></span>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="2">
                                                            <v-text-field
                                                                v-model="filterValue.event_sitemap"
                                                                @focus="isTextFieldFocused = true"
                                                                @blur="isTextFieldFocused = false"
                                                                :class="{ 'base-color': isTextFieldFocused }"
                                                                prepend-icon="mdi-text-search-variant"
                                                                class="my-page orange-text-field"
                                                                color="#17468f"
                                                                clearable
                                                                autofocus
                                                                flat
                                                            ></v-text-field>
                                                        </v-col>                  
                                                    </v-row>
                                                </div>
                                            </template>
                                            <template v-slot:[`item.code`]="{ item }">
                                                <span class="system_textdata_color">{{ item.code }}</span>
                                            </template>
                                            <template v-slot:[`item.name`]="{ item }">
                                                <span class="system_textdata_color">{{ item.name }}</span>
                                            </template>
                                            <template v-slot:[`item.link`]="{ item }">
                                                <span class="system_textdata_color">{{ item.link }}</span>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'event_detail')"
                                                                >mdi-delete</v-icon
                                                            >
                        
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                
                                    <!-- User Details -->
                                    <v-tab-item>
                                        <v-data-table 
                                            :headers="user_headers" 
                                            :items="items" 
                                            :search="filterValue.event_sitemap"
                                            :server-items-length="pagination.totalItems"
                                            :options.sync="pagination"
                                            @update:options="onPaginationChange"
                                            class="elevation-1 orange-border system_admin_table_color flexible-table" 
                                            style="background-color: black;"
                                        >
                                            <template v-slot:[`header.code`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.name`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.link`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                            <template v-slot:[`header.action`]="{ header }">
                                                <span class="system_tableheader_color">{{ header.text }}</span>
                                            </template>
                                        
                                            <template v-slot:top>
                                                <div class="system_admin_font_family_primary" style="padding:0px;">
                                                    <v-row>
                                                        
                                                        <v-col cols="2">
                                                            <v-btn
                                                                @click="dialogTrigger('Submit')"
                                                                
                                                                class="ml-1 mt-1 system_admin_button_color"
                                                                >
                                                                <span class="system_text_button_color"><v-icon class="system_text_button_color" color="">mdi-plus</v-icon>
                                                                <span class="system_text_button_color">
                                                                    Add
                                                                </span></span>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-spacer></v-spacer>
                                                        <v-col cols="2">
                                                            <v-text-field
                                                                v-model="filterValue.event_sitemap"
                                                                @focus="isTextFieldFocused = true"
                                                                @blur="isTextFieldFocused = false"
                                                                :class="{ 'base-color': isTextFieldFocused }"
                                                                prepend-icon="mdi-text-search-variant"
                                                                class="my-page orange-text-field"
                                                                color="#17468f"
                                                                clearable
                                                                autofocus
                                                                flat
                                                            ></v-text-field>
                                                        </v-col>                  
                                                    </v-row>
                                                </div>
                                            </template>
                                            <template v-slot:[`item.code`]="{ item }">
                                                <span class="system_textdata_color">{{ item.code }}</span>
                                            </template>
                                            <template v-slot:[`item.name`]="{ item }">
                                                <span class="system_textdata_color">{{ item.name }}</span>
                                            </template>
                                            <template v-slot:[`item.link`]="{ item }">
                                                <span class="system_textdata_color">{{ item.link }}</span>
                                            </template>
                                            <template v-slot:[`item.action`]="{item}">
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('View', item)"
                                                                color="#17468f"
                                                                class="btn-action"
                                                                small
                                                                >mdi-eye</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>View Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="#17468f">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="#17468f"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                @click="dialogTrigger('Update', item)"
                                                                color="blue"
                                                                class="btn-action"
                                                                small
                                                                >mdi-square-edit-outline</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Edit Record</span>
                                                </v-tooltip>
                                                <v-tooltip bottom color="red">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn text icon color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            <v-icon
                                                                class="btn-action"
                                                                small
                                                                @click="deleteRecord(item.id, 'user_detail')"
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Delete Record</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                                    <v-tab-item v-if="user.super_admin">
                                        <ModuleSettingsTableComponentVue/>
                                    </v-tab-item>
                                </v-tabs-items>										
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
            <DialogComponent :cp="components" :hide_overlay="false" :scrollable="true" :width="height('60%')" :retain-focus="false"></DialogComponent>
        </v-col>
    </v-row>
</template>
  
  <script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs/dist/exceljs.min.js';
import moment from 'moment';
import jsPDF from 'jspdf';
import JSZip from "jszip";
import QRCode from "qrcode";

import Swal from 'sweetalert2';
import { defineComponent } from 'vue';
import DialogComponent from "@/components/layouts/dialogs/Dialog.vue"
import { mapGetters } from 'vuex';
import SharedFunctionsComponent from '@/components/shared/SharedFunctionsComponent.vue'
import draggable from 'vuedraggable'
import ModuleSettingsTableComponentVue from "@/components/modules/settings/ModuleSettingsTableComponent.vue"

import RafflePrizesComponentView from "@/components/layouts/dialogs/dashboard/RafflePrizesComponentView.vue"
import ActivitiesComponentViewVue from '@/components/layouts/dialogs/activities/ActivitiesComponentView.vue';
import ProgramFlowImageComponentViewVue from '@/components/layouts/dialogs/programFlow/ProgramFlowImageComponentView.vue';
import EventDetailsView from '@/components/layouts/dialogs/EventDetails/EventDetailsComponent.vue';
import EventNomineesComponentView from '@/components/layouts/dialogs/nominees/EventNomineesComponentView.vue'
import EventSitemapComponentView from '@/components/layouts/dialogs/sitemap/EventSitemapComponentView.vue'
import CompanyComponentViewVue from '@/components/layouts/dialogs/company/CompanyComponentView.vue';
import UserDetailsComponentView from './layouts/dialogs/UserDetails/UserDetailsComponentView.vue';
import ReportsCardComponentVue from '@/components/shared/ReportsCardComponent.vue';
// import EventProgram from '@/components/layouts/dialogs/events/EventsProgram.vue';

export default {
	mixins: [
		SharedFunctionsComponent
	],
	data() {
		return {
			downloadParticipantsDialog: false,
			uploadParticipantsDialog: false,
			uploadParticipantsDialog: false,
			uploadRafflePrizesDialog: false,
			uploadRafflePrizesFilterIncomplete: false,
			rafflePrizeUploadedFile: null,
			downloadCompanyDialog: false,
			addParticipantReference: '',
			addParticipantLastName: '',
			addParticipantFirstName: '',
			addParticipantMiddleName: '',
			addParticipantTableNumber: '',
			addParticipantCompanyID: '',
			addDepartmentID: '',
			addTenureCode: '',
			addParticipantBuffetNumber: '',
			addParticipantMobileBarTicket: '',
			addParticipantIncludeRaffle: 0,
			addParticipantGender: 0,
			generatedref: '',
			isScrolled: false,
			isContentScrollable: false, 
			eventDetails: '',
			addParticipantDialog: false,
			loginDialog: false,
			loggedIn: false,
			isTextFieldFocused: false,
			username: '',
			showBackToTop: false,
			scrollContainer: null,
			hovered: false,
			addParticipantData: [],
			data: [], 
			event_details:[],
			validateKeys: [],
			password: '',
			screenHeight: window.innerHeight,
			showPassword: false,  
			items: [
				{showDialog: false },
			],
			headers: [
                { text: 'Guest Name', align: 'start', sortable: true, value: 'full_name', grouping: [1, 2], class:"system_tableheader_color" },
                { text: 'Reference #', value: 'employee_id', grouping: [1] },
                { text: 'Company', value: 'company_name', grouping: [1, 2] },
                { text: 'Unique Code', value: 'unique_code', grouping: [1, 2] },
                { text: 'Company Pax', align: 'center', value: 'company_pax', grouping: [1, 2] },  // Added align: 'center' here
                { text: 'Table #', align: 'center', value: 'table_num', grouping: [1, 2] },
                { text: 'Tenure Code', value: 'tenure_code_name', grouping: [1] },
                { text: 'Buffet Table', value: 'buffet_meal_name', grouping: [1] },
                { text: 'Time Registered', align: 'center', value: 'time_in', grouping: [1, 2] },
                { text: 'Attended', align: 'center', value: 'attended', grouping: [1, 2] },
                { text: 'Not Attended', align: 'center', value: 'not_attended', grouping: [1, 2] },
                { text: 'Actions', align: 'center', value: 'actions', grouping: [1, 2] },
			],
			employeeDatas: [],
			tab: {
				index: parseInt(localStorage.getItem("activeTab")) || 0,
				url: ['event-participants', 'companyRoute','rafflePrizes', 'eventActivities', 'programFlowImage', 'eventNominees', 'eventSitemap' ,'event_detail','user_detail','moduleSettings'],
				component: ['', CompanyComponentViewVue, RafflePrizesComponentView, ActivitiesComponentViewVue, ProgramFlowImageComponentViewVue, EventNomineesComponentView, EventSitemapComponentView ,EventDetailsView,UserDetailsComponentView,'']
			},
			raffle_headers:[
				{ text: 'Image', value: 'image_path'},,
				{ text: 'Code', value: 'code',text_class: 'system_text_button_color'}, 
				{ text: 'Name', value: 'name'},
				{ text: 'Winner Count', value: 'winner_count'},
				{ text: 'Tenure Codes', value: 'tenure_codes'},
				{ text: 'Raffle Group', value: 'raffle_group_name'},
				{ text: 'Priority', value: 'priority', align: 'center'},
				{ text: 'Order', value: 'order'},
				{ text: 'Action', value: 'action'},
			],
			user_headers:[
				{text: 'Name', value:'name'},
				{text: 'Username', value:'username'},
				{text: 'Super Admin', value:'super_admin'},
				{text: 'Action' , value:'action'},
			],
			activities_headers:[
				// { text: 'Image', value: 'image_path', width: '5%'},
				{ text: 'Name', value: 'name'},
				{ text: 'Description', value: 'description'},
				{ text: 'Action', value: 'action', width: '10%', align:'center'},
			],
			program_flow_headers:[
				{ text: 'Image', value: 'image_path'},
				{ text: 'Order', value: 'order'},
				{ text: 'Action', value: 'action'},
			],
			event_nominee_headers:[
				{ text: 'Full Name', value: 'full_name'},
				{ text: 'Company Name', value: 'company_name'},
				// { text: 'Nomination Count', value: 'nomination_count'},
				{ text: 'Vote Count', value: 'vote_count'},
				{ text: 'Action', value: 'action'},
			],
			event_sitemap_headers:[
				{ text: 'Image', value: 'image_path'},
				{ text: 'Order', value: 'order'},
				{ text: 'Action', value: 'action'},
			],
			event_details_headers:[
				{text:'Code', value: 'code'},
				{text:'Name', value: 'name'},
				{text:'Link', value: 'link'},
				{text:'Action', value: 'action'},
			],
			company_headers:[
				{ text: 'Code', value: 'code'},
				{ text: 'Name', value: 'name'},
				{ text: 'No. Of Tickets', value: 'no_of_tickets'},
				{ text: 'Action', value: 'action'},
			],
			items: [],
			token: localStorage.getItem("token"),
			someOtherData: JSON.parse(localStorage.getItem("someOtherData")) || {},
			components: '',
			current_index: null,
			orderPrizeDialog: false,
			changePasswordModal : false,
			draggable_items: [],
			priorityRafflePrizes: [],
			filterPriority: false,
			priorityRaffleHeaders: [
				{ text: 'Order', value: 'priority_order', sortable: true, width: '80px' },
				{ text: 'Code', value: 'code', sortable: true },
				{ text: 'Name', value: 'name', sortable: true },
				{ text: 'Raffle Group', value: 'raffle_group_name', sortable: true },
				{ text: 'Raffle Drawn', value: 'raffle_drawn', sortable: true },
				{ text: 'Actions', value: 'action', sortable: false, align: 'center' }
			],
			flowDialog: false,
			dropdowns:{
				gender:[
					{text: 'Male', value: "M"},
					{text: 'Female', value: "F"},
				],
				company_list: [],
				event_list: [],
				status: [
					{text: "All", value: -1},
					{text: "Attended", value: 2 },
					{text: "Not Attended", value: 1},
				],
				department_list: [],
				tenure_list: [],
				buffet_table_list: [],
                raffle_group_list: [], 
			},
			filterValue:{
				guest_list_search: '',
				guest_list_search_employee_id: '',
				company_list: '',
				raffle_prizes: '',
				activities: '',
				program_flow: '',
				event_nominees: '',
				event_sitemap: '',
				event_details: '',
				ticket_num: '',
                guest_list_search_table_search: ''
			},
			nominee_tabs: [
				{ text: "Mr", gender: 'M',icon:'mdi-chess-king'},
				{ text: "Ms", gender: 'F',icon:'mdi-chess-queen'},
			],
			n_tab: 0,
			loading: {
				datatable: false,
				button: false,
                generatePDF: false,
                massPdf: false,
                guest_export: false
			},
			filters:{
				company_id: [],
				status: null
			},
			options:{
				guest_list: {}
			},
			
			cards: [
				{ title: 'Total Expected Attendees', icon: 'mdi-account-group', icon_class: 'system_totalpax_card_color', cols: 6, sm: 6, md: 6, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_pax' },
				{ title: 'Total Attended', icon: 'mdi-account-multiple-check', icon_class: 'system_totalattended_card_color', cols: 6, sm: 6, md: 6, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_attended' },
				{ title: 'Not Attended', icon: 'mdi-account-multiple-minus', icon_class: 'system_notattended_card_color', cols: 6, sm: 6, md: 6, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_unattended' },
				{ title: 'Total Attended %', icon: 'mdi-percent-circle-outline', icon_class: 'system_totalpercent_card_color', cols: 6, sm: 6, md: 6, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_attended_percent' },
			],
			totals: {
				total_pax: 100,
				total_attended: 0,
				total_unattended: 0,
				total_attended_percent: 0,
			},
			cardsCompany: [
				{ title: 'Total Company', icon: 'mdi-account-group', icon_class: 'system_totalcompany_card_color', cols: 6, sm: 6, md: 3, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_company' },
				{ title: 'Total Attended', icon: 'mdi-account-multiple-check', icon_class: 'system_totalattended_card_color', cols: 6, sm: 6, md: 3, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_company_attended' },
				{ title: 'Not Attended', icon: 'mdi-account-multiple-minus', icon_class: 'system_notattended_card_color', cols: 6, sm: 6, md: 3, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_company_unattended' },
				{ title: 'Total Attended %', icon: 'mdi-percent-circle-outline', icon_class: 'system_totalpercent_card_color', cols: 6, sm: 6, md: 3, lg: 3, xl: 3, prefix: ' ', suffix: '', filter: 'currency', value: 'total_company_attended_percent' },
			],

			totalsCompany: {
				total_company: 0,
				total_company_attended: 0,
				total_company_unattended: 0,
				total_company_attended_percent: 0,
			},

			defaults: {
				status: -1,
				event_id: 1
			},
			settings: {
				data_grouping: null,
				include_raffle_grouping: null,
			},
			arrayBuffer:	null,
			fileList:	null,
			batchAdditionItems: [],
			batchRafflePrizeItems: [],
			have_img:	false,
			rafflePrizeHaveImg: false,
			disabled_view: false,
			loading_text: '',
			rafflePrizeLoadingText: '',
			loaded: true,
			rafflePrizeLoaded: true,
			rafflePrizeArrayBuffer: null,
			rafflePrizeFile: null,
			user: {},
			form:{
				currentPassword: '',
				newPassword: '',
				newPasswordConfirmation: '',
			},
			errors: {
				currentPassword: [],
				newPassword: [],
				confirmPassword: []
			},
			isFirstLoad: true,
			company_items: [],
			pagination: {
				page: 1,
				itemsPerPage: 10,
			},
			totalItems: 0,
			import_guest_headers: [
				{ text: 'EMPLOYEE ID', align: 'center', sortable: true, value: 'employee_id', grouping: [1], class:"system_tableheader_color" },
				{ text: 'COMPANY', align: 'center', sortable: true, value: 'company_name', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'LAST NAME', align: 'center', sortable: true, value: 'last_name', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'FIRST NAME', align: 'center', sortable: true, value: 'first_name', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'MIDDLE NAME', align: 'center', sortable: true, value: 'middle_name', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'DEPARTMENT', align: 'center', sortable: true, value: 'department_name', grouping: [1], class:"system_tableheader_color" },
				{ text: 'BUFFET', align: 'center', sortable: true, value: 'buffet_num', grouping: [1], class:"system_tableheader_color" },
				{ text: 'TENURE CODE', align: 'center', sortable: true, value: 'tenure_code', grouping: [1], class:"system_tableheader_color" },
				{ text: 'GENDER', align: 'center', sortable: true, value: 'gender', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'TABLE', align: 'center', sortable: true, value: 'table', grouping: [1, 2], class:"system_tableheader_color" },
				{ text: 'UNIQUE CODE', align: 'center', sortable: true, value: 'unique_code', grouping: [1, 2], class:"system_tableheader_color" },
			],
			import_raffle_prize_headers: [
				{ text: 'Image', align: 'center', sortable: true, value: 'image_path', class:"system_tableheader_color" },
				{ text: 'Code', align: 'start', sortable: true, value: 'code', class:"system_tableheader_color" },
				{ text: 'Name', align: 'start', sortable: true, value: 'name', class:"system_tableheader_color" },
				{ text: 'Tenure Categories', align: 'center', sortable: true, value: 'tenure_categories', class:"system_tableheader_color" },
				{ text: 'Winner Count', align: 'center', sortable: true, value: 'winner_count', class:"system_tableheader_color" },
				{ text: 'Order', align: 'center', sortable: true, value: 'order', class:"system_tableheader_color" },
				{ text: 'Batch', align: 'center', sortable: true, value: 'batch', class:"system_tableheader_color" },
				{ text: 'Suspense Animate', align: 'center', sortable: true, value: 'suspense_animate', class:"system_tableheader_color" },
			],
            raffleGroupDialog: false,
            raffle_groups: [],
            selected_for_qr_generation: [],
            qr_code:{
                width: 90,
                height: 90,
                start_y: 40
            }
		};
	},
	created(){
		// this.getUser();
	},
	async mounted(){
        this.getRafflePrizeAll()
		this.getCompanyDropdowns();
		await this.getEventDropdowns()
		this.loginDialog = this.token ? false: true
		this.getTableData(this.tab.index);
		this.getGroupingSettings();
		await this.setDefaultFilter();
		window.addEventListener('scroll', this.handleScroll);
		// window.addEventListener('resize', () => { this.getScreenHeight = window.innerHeight});
		if (this.token) {
    		this.getUser();
            this.getDepartments();
            this.getTenureCategory();
            this.getBuffetTableList();
            this.getRaffleGroupDropdown();
			this.loggedIn = true;
		}
	},
	components:{
		DialogComponent,
		RafflePrizesComponentView,
		draggable,
		ModuleSettingsTableComponentVue,
		ProgramFlowImageComponentViewVue,
		EventSitemapComponentView,
		CompanyComponentViewVue,
		ReportsCardComponentVue,
		UserDetailsComponentView,
		ActivitiesComponentViewVue,
		EventNomineesComponentView,
		EventDetailsView,
		EventNomineesComponentView,
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
		// window.removeEventListener('resize', this.getScreenHeight);
	},
	methods: {
		getUser(){
			let payload = {
				url: 'user'
			}
			this.$store.dispatch('urlGet', payload).then((res)=>{
				this.user = res;
			})
		},
		openChangePasswordModal() {
			this.changePasswordModal = true; 
			this.form.currentPassword = '';
			this.form.newPassword = '';
			this.form.newPasswordConfirmation = '';
		},
		closeChangePasswordModal() {
			this.changePasswordModal = false;
			this.form.currentPassword = '';
			this.form.newPassword = '';
			this.form.newPasswordConfirmation = '';
		},
		handleScroll() {
			if (window.scrollY > 100) {
				this.isScrolled = true;
			} else {
				this.scrollTop = false;
			}
		},
		scrollTop() {
			const scrollableElement = this.$refs.scrollableCard.$el;
			window.scrollTo(0,0);
		},
        scrollTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
		onScroll(event) {
			const scrollableElement = this.$refs.scrollableCard.$el;
			const scrollTop = scrollableElement.scrollTop;
			const clientHeight = scrollableElement.clientHeight;
			const scrollHeight = scrollableElement.scrollHeight;
			this.isContentScrollable = scrollHeight > clientHeight;
			if (this.isContentScrollable) {
			 this.isScrolled = scrollTop > 100;
			}
		},
		closeDialog(item) {
			item.showDialog = false;
		},
		toggeaddParticipantDialog(){
			this.addParticipantDialog = !this.addParticipantDialog;
			this.generatedref = '';
			this.resetFields();
			
		},
		async submitChanges(item) {
			Swal.fire({
				title: 'Submitting',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
			});
			Swal.showLoading();
			this.data = [];
			this.data.push({
				...item
			});
			let payload = {
				url: "modify-participants",
				id: this.data,
			};

			try {
				let response = await this.$store.dispatch("urlPost", payload);
				if (response.message === "Attendee Data Updated Successfully!") {
					Swal.fire({
						title: 'UPDATED',
						text: response.message,
						icon: 'success',
						allowOutsideClick: false,
						customClass: {
							confirmButton: 'orange-button',
						}
					});
					this.$store.commit('NEW_MASTER_DATA', true);
					this.closeDialog();
					this.fetchData();
				}
			} catch (error) {
				if (error.response && error.response.status === 500) {
					Swal.fire({
						title: "<strong><u>NOT FOUND</u></strong>",
						text: error.response.data.message, 
						icon: 'warning',
						allowOutsideClick: false,
						customClass: {
							confirmButton: 'orange-button',
						}
					});
				} 
			}
		},
		deleteNominee(item) {
			Swal.fire({
				title: "Delete Nominee",
				text: `Are you sure you want to delete`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '397373',
				cancelButtonColor:'grey',
				confirmButtonText: 'Yes, delete it!',
				reverseButtons:true,
			}).then((result) => {
				if (result.isConfirmed) {
					let payload = {
						url: 'delete-nominee', 
						id: item.id,
						event_id: this.GET_EVENT_ID
					};

					this.$store.dispatch('urlDelete', payload).then((response) => {
						Swal.fire(
							'Deleted!',
							`${item.full_name} has been deleted.`,
							'success'
						);

					}).catch((error) => {
						Swal.fire(
							'Error!',
							'There was an error deleting the nominee.',
							'error'
						);
					});
				}
			});
		},
		async fetchData() {
			try {
				this.loading.datatable = true;
				let response = await axios.get(process.env.VUE_APP_API_HOST + '/api/event-participants', {
					params: {
						page: this.pageNumber, 
						limit: 20, 
					},
				});
				if (response.data) {
					if (this.pageNumber === 1) {
						this.employeeDatas = response.data.eventParticipants; 
					} else {
						this.employeeDatas = [...this.employeeDatas, ...response.data.eventParticipants]; 
					}

					this.pageNumber += 1;
					this.loading.datatable = false;
					this.$forceUpdate(); 
				}
			} catch(error) {
				console.error(error);
				this.loading.datatable = false;
			}
		},
		async changePassword() {
			if (this.form.newPassword !== this.form.newPasswordConfirmation) {
				Swal.fire('Error', 'New passwords do not match', 'error');
				return;
			}
			try {
				const payload = {
					current_password: this.form.currentPassword,
					new_password: this.form.newPassword,
					new_password_confirmation: this.form.newPasswordConfirmation
				};

				const response = await this.$store.dispatch('urlPost', { 
					url: 'changePassword', 
					...payload
				})

				if (response.status === 200) {
					Swal.fire('Error', 'Password change failed. Please try again.', 'error');
					this.form.currentPassword = '';
					this.form.newPassword = '';
					this.form.newPasswordConfirmation = '';
				} else {
					Swal.fire('Success', response.message || 'Password change failed. Please try again.', 'success');
					this.form.currentPassword = '';
					this.form.newPassword = '';
					this.form.newPasswordConfirmation = '';
				}
				} catch (error) {
					Swal.fire('Error', 'Password change failed. Please try again.', 'error');
					console.error("Password change failed:", error);
				}
			this.form.currentPassword = '';
			this.form.newPassword = '';
			this.form.newPasswordConfirmation = '';
			this.changePasswordModal = false;
		},

		async loginClicked() {
			Swal.fire({
				title: 'Please Wait',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
			});
			Swal.showLoading();
			try {
				let responseAccess = await axios.post(`${process.env.VUE_APP_API_HOST}/api/event-portal`, {
					username: this.username,
					password: this.password,
				});

				localStorage.setItem("token", responseAccess.data.access_token);
				localStorage.setItem("someOtherData", JSON.stringify(responseAccess.data.user)); 

				Swal.close();
				this.loggedIn = true;
				this.loginDialog = false;
				this.token = localStorage.getItem("token");
				this.someOtherData = localStorage.getItem("someOtherData"); 
				window.location.reload();
				this.getTableData(0);
			} catch (error) {
				console.log('Error during login:', error);
				Swal.fire({
					icon: 'error',
					title: 'Invalid username or password',
					text: 'Please try again',
					showConfirmButton: false,
					timer: 1500,
				});
			}
		},
	// async fetchDataPeriodically() {
	//   while (this.loggedIn) {
	//     try {
	//       let response = await axios.get(process.env.VUE_APP_API_HOST + '/api/event-participants');
	//       this.employeeDatas = response.data.eventParticipants;
	//     } catch (error) {
	//       console.error('Error fetching data:', error);
	//     }
	//     // Wait for 5 seconds before fetching again
	//     await new Promise(resolve => setTimeout(resolve, 20000));
	//   }
	// },
		// filterData() {
		// 	let filterText = this.filterValue.toLowerCase();
		// 	this.filteredEmployeeDatas = this.employeeDatas.filter((employee) => employee.full_name.toLowerCase().includes(filterText) || employee.employee_id.toLowerCase().includes(filterText));
		// },
		async downloadExcel() {
            Swal.fire({
				title: 'Exporting Data...',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
			});
			Swal.showLoading();
			let payload = {
				url: "event-participants",
				export: 1,
			};
			try {
				let response = await this.$store.dispatch("urlGet", payload);
				let employeeDatas = response.data;
				let data = employeeDatas.map(employee => ({
					'COMPANY': employee.company_name,
					'REF#': this.settings.data_grouping == 1 ? employee.employee_id : employee.ticket_num,
					'LAST NAME': employee.last_name,
					'FIRST NAME': employee.first_name,
					'MIDDLE NAME': employee.middle_name,
					'GENDER': employee.gender,
					'TABLE': employee.table_num,
					'UNIQUE CODE': employee.unique_code,
					// 'Buffet #': employee.buffet_meal_id,
					'STATUS': employee.status_id == 1 ? 'Not Attended' : 'Attended',
					'TIME REGISTERED': employee.time_in,
				}));

				let wb = XLSX.utils.book_new();
				let ws = XLSX.utils.json_to_sheet(data);
				this.autoFitColumns(ws, data);
				
				let payload1 = {
					url: 'companyExport'
				};
				let response1 = await this.$store.dispatch("urlPost", payload1);
				let data1 = response1.map(company => ({
					'Name': company.name,
					// 'Ticket Count': company.no_of_tickets,
					'Pax Count': company.pax_count,
				}));
				let ws2 = XLSX.utils.json_to_sheet(data1);
				this.autoFitColumns(ws2, data1);

				XLSX.utils.book_append_sheet(wb, ws, 'Guests');
				XLSX.utils.book_append_sheet(wb, ws2, 'Company');

				// let payload2 = {
				// 	url: 'companyExcel'
				// };
				// let response2 = await this.$store.dispatch("urlPost", payload2);
				// let data2 = response2.detailed.map(company => ({
				// 	'Name': company.Name,
				// 	'Ticket #': company.ticket_num,
				// }));
				// let ws3 = XLSX.utils.json_to_sheet(data2);
				// XLSX.utils.book_append_sheet(wb, ws3, 'Tickets');
				// this.autoFitColumns(ws3, data2);
				let excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
				let blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${this.GET_EVENT_NAME.replace(" ", "").toUpperCase()}_Official_Participants.xlsx`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				this.downloadParticipantsDialog = false;
                Swal.close();
				Swal.fire({
					title: "Check your Downloads!",
					text: "Data Downloaded Successfully!",
					icon: "success",
					allowOutsideClick: false,
					customClass: {
						confirmButton: 'orange-button',
					},
				});
			} catch (error) {
                Swal.close();
				console.error(error);
			}
		},

		autoFitColumns(worksheet, jsonData) {
			const colWidths = [];
			for (const colName of Object.keys(jsonData[0] || {})) {
				const maxLength = Math.max(
					...jsonData.map(row => (row[colName] ? row[colName].toString().length : 0)),
					colName.length
				);
				colWidths.push({ wch: maxLength + 2 });
			}
			worksheet['!cols'] = colWidths;
		},

		reloadPage() {
			window.location.reload();
		},
		async addParticipant() {
			Swal.fire({
				title: 'Saving',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
			});
			Swal.showLoading();
			this.addParticipantData.push({
				reference_number: this.generatedref,
				first_name: this.addParticipantFirstName,
				last_name: this.addParticipantLastName,
				middle_name: this.addParticipantMiddleName,
				table_num: this.addParticipantTableNumber,
				company_id: this.addParticipantCompanyID,
				buffet_meal_id: this.addParticipantBuffetNumber,
				mobile_bar_count: this.addParticipantMobileBarTicket,
				include_raffle: this.addParticipantIncludeRaffle,
				gender: this.addParticipantGender,
				department_id: this.addDepartmentID,
				tenure_code_id: this.addTenureCode
			});
			let payload = {
				url: "add-participants",
				id: this.addParticipantData,
				event_id: this.GET_EVENT_ID
			};
			try {
				// let response = await axios.post(process.env.VUE_APP_API_HOST + '/api/add-participants', this.addParticipantData);
				await this.$store.dispatch("urlPost", payload)
				Swal.fire({
					title: 'SUCCESS',
					text: "Participant Added!",
					icon: 'success',
					allowOutsideClick: false,
					customClass: {
						confirmButton: 'orange-button',
					}
				});
				this.fetchData(); 
				this.toggeaddParticipantDialog();
				this.resetFields();
				this.getTableData(0);
			} catch (error) {
				if (error.response.status === 500) {
					Swal.fire({
						title: "<strong><u>Already Exists!</u></strong>",
						text: error.response.data.message, 
						icon: 'warning',
						allowOutsideClick: false,
						customClass: {
							confirmButton: 'orange-button',
						} 
					});
				} 
			}
			this.addParticipantData = [];
		},
		async getTableDataEventDetails(){
			payload
		},
		searchInput() {
			const searchTerm = this.filterValue.raffle_prizes.trim();
				if (searchTerm !== '') {
					this.getTableData(this.current_index, { search: searchTerm });
				} else {
					this.getTableData(this.current_index, {});
				}
		},
		async getTableData(index = 0, other_payload = {}, isExport = 0) {
			if (!this.token) {
				this.loginDialog = true;
				return;
			}

			this.loading.datatable = true;
			this.items = [];
			this.company_items = [];
			localStorage.setItem("activeTab", index);
			let payload = {
				url: this.tab.url[index],
				...other_payload,
				...this.filters,
				...this.options,
				...this.filterValue,
				...this.pagination,
                guest_list_search: this.filterValue.guest_list_search,
                guest_list_search_employee_id: this.filterValue.guest_list_search_employee_id,
                guest_list_search_table_search: this.filterValue.guest_list_search_table_search,
				search: this.filterValue.raffle_prizes || "",
				export: isExport,
				event_id: this.GET_EVENT_ID,
				priority: index === 2 && this.filterPriority ? 1 : null,
				// page: this.currentPage,
				// perPage: this.pageSize,
			};

			if (this.isRaffleHeadersTab(index)) {
				payload.include = this.getRaffleHeadersFields(this.filterValue);
			}

			this.current_index = index;
			this.components = this.tab.component[index];

			try {
				const res = await this.$store.dispatch('urlGet', payload);
				this.items = res.data;
				this.company_items = res.data;

				if (isExport === 0) {
					if (res.total_data) {
						Object.assign(this.totals, {
							total_attended: res.total_data.total_attended,
							total_attended_percent: (this.isFirstLoad || this.filters.status == -1)
								? res.total_data.total_attended_percent
								: this.totals.total_attended_percent,
							total_pax: res.total_data.total_pax,
							total_unattended: res.total_data.total_unattended,
						});
						Object.assign(this.totalsCompany, {
							total_company: res.total_data.total_company,
							total_company_attended: res.total_data.total_company_attended,
							total_company_attended_percent: (this.isFirstLoad || this.filters.status == -1)
								? res.total_data.total_company_attended_percent
								: this.totalsCompany.total_company_attended_percent,
							total_company_unattended: res.total_data.total_company_unattended,
						});
						this.isFirstLoad = false;
						this.getGroupingSettings();
						this.getEventDropdowns();
					} else {
						console.warn(`total_data is undefined in response for tab ${index}. Response:`, res);
						this.resetTotals();
					}

					this.totalItems = res.total || 0;
					// this.totalPages = Math.ceil(this.totalItems / this.pageSize);
				}
			} catch (error) {
				console.error(`Error fetching data for tab ${index}:`, error);

				if (error.response?.status === 401) {
					Swal.fire({
						title: 'Unauthenticated!',
						text: '',
						icon: 'error',
						allowOutsideClick: false,
					}).then((result) => {
						if (result.isConfirmed) {
							localStorage.removeItem("token");
							window.location.reload();
							this.$router.push('/');
						}
					});
				} else {
					console.error(`Unexpected error: ${error.message}`);
				}
			} finally {
				this.loading.datatable = false;
			}
		},

		// async getTableData(index = 0, other_payload = {}, isExport = 0) {
		// 	if (!this.token) {
		// 		this.loginDialog = true;
		// 		return;
		// 	}

		// 	try {
		// 		this.loading.datatable = true;
		// 		this.items = [];
		// 		this.company_items = [];
		// 		localStorage.setItem("activeTab", index);

		// 		let payload = {
		// 			url: this.tab.url[index],
		// 			...other_payload,
		// 			...this.filters,
		// 			...this.options,
		// 			...this.filterValue,
		// 			search: this.filterValue.raffle_prizes,
		// 			export: isExport,
		// 			event_id: this.GET_EVENT_ID,
		// 			page: this.currentPage,
		// 			perPage: this.pageSize,
		// 		};

		// 		if (this.isRaffleHeadersTab(index)) {
		// 			payload.include = this.getRaffleHeadersFields(this.filterValue);
		// 		}

		// 		this.current_index = index;
		// 		this.components = this.tab.component[index];
				
		// 		const res = await this.$store.dispatch('urlGet', payload);
		// 		this.items = res.data;
		// 		this.company_items = res.data;

		// 		this.totalItems = res.total || 0;
		// 		this.totalPages = Math.ceil(this.totalItems / this.pageSize);
		// 		if (isExport === 0) {
		// 			Object.assign(this.totals, {
		// 				total_attended: res.total_data.total_attended,
		// 				total_attended_percent: this.isFirstLoad || this.filters.status == -1
		// 					? res.total_data.total_attended_percent
		// 					: this.totals.total_attended_percent,
		// 				total_pax: res.total_data.total_pax,
		// 				total_unattended: res.total_data.total_unattended,
		// 			});
		// 			Object.assign(this.totalsCompany, {
		// 				total_company: res.total_data.total_company,
		// 				total_company_attended: res.total_data.total_company_attended,
		// 				total_company_attended_percent: this.isFirstLoad || this.filters.status == -1
		// 					? res.total_data.total_company_attended_percent
		// 					: this.totalsCompany.total_company_attended_percent,
		// 				total_company_unattended: res.total_data.total_company_unattended,
		// 			});
		// 			this.isFirstLoad = false;
		// 			this.getGroupingSettings();
		// 			this.getEventDropdowns();

		// 			if (res.total !== undefined) {
		// 				this.totalItems = res.total;
		// 				this.totalPages = Math.ceil(this.totalItems / this.pageSize);
		// 			} else {
		// 				console.warn(`Total is undefined for tab ${index}. Response:`, res);
		// 				this.resetTotals();
		// 			}
		// 		}
		// 	} catch (error) {
		// 		console.error(`Error fetching data for tab ${index}:`, error);
		// 	} finally {
		// 		this.loading.datatable = false;
		// 	}
		// },
		isRaffleHeadersTab(index) {
			return index === this.raffleHeadersTabIndex; 
		},

		getRaffleHeadersFields(filterValue) {
			const fields = this.raffle_headers.map(header => header.value);
			if (this.filterValue && filterValue.raffle_prizes) {
				return fields.filter(field => field.toLowerCase().includes(filterValue.raffle_prizes.toLowerCase()));				
			}
			// return this.raffle_headers.map(header => header.value);
			return fields;
		},

		async onPaginationChange(options) {
			this.pagination = options;
			this.currentPage = this.pagination.page || 1;
			this.pageSize = this.pagination.itemsPerPage || 10;
			
			await this.getTableData(this.current_index);
		},

		handlePageChange(newPage) {
			// this.currentPage = newPage; 
			// this.getTableData(this.current_index); 
			this.pagination.page = newPage;
			this.onPaginationChange(this.pagination);
		},

		handleItemsPerPageChange(newItemsPerPage) {
			// this.pageSize = newItemsPerPage; 
			// this.currentPage = 1; 
			// this.getTableData(this.current_index);
			this.pagination.itemsPerPage = newItemsPerPage;
			this.onPaginationChange(this.pagination);
		},
		changePage(page) {
			if (page > 0 && page <= this.totalPages) {
				this.currentPage = page;
				this.getTableData(this.current_index); 
			}
		},
		resetTotals() {
			this.totals = {
				total_attended: 0,
				total_attended_percent: 0,
				total_pax: 0,
				total_unattended: 0,
			};
			this.totalsCompany = {
				total_company: 0,
				total_company_attended: 0,
				total_company_attended_percent: 0,
				total_company_unattended: 0,
			};
		},
		height(width) {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return "100%"
				case 'sm': return "100%"
				case 'md': return width
				case 'lg': return width
				case 'xl': return width
			}
		},
		dialogTrigger(action, item = null, request = 0){
			if(request == 1){
				let payload = {
					url: 'eventNominees',
					id: item.id
				}
				this.$store.dispatch('urlShow', payload).then((res)=>{
					this.$store.commit('DIALOG_VIEW', res);
					this.$store.commit('DIALOG', true);
					this.$store.commit('ACTION', action);
				})
			}
			else if (this.tab.index == 2 && action != 'Submit'){
				let payload = {
					url: 'getRafflePrizeWinner',
					id: item.id
				}
				this.$store.dispatch('urlPost', payload).then(response=>{
					item.winner_details = response
					this.$store.commit('DIALOG', true);
					this.$store.commit('ACTION', action);
					this.$store.commit('DIALOG_VIEW', item);
				})
			}
			else{
				this.$store.commit('DIALOG', true);
				this.$store.commit('ACTION', action);
				this.$store.commit('DIALOG_VIEW', item);
			}
			this.getEventDropdowns();
		},
			deleteRecord(id = null, url = ''){
				Swal.fire({
					title: "Delete",
					text: `Are you sure you want to delete ?`,
					icon: 'question',
					showConfirmButton:true,
					confirmButtonText:'Confirm',
					showCancelButton:true,
					showCloseButton:true,
					confirmButtonColor: '397373',
					cancelButtonColor:'grey',
					reverseButtons:true,
				})
				.then((result) => {
					if (result.isConfirmed) {
						let payload = {
							url: url,
							id: id,
							event_id: this.GET_EVENT_ID
						}
						this.$store.dispatch('urlDelete', payload).then((res)=>{
							Swal.fire(
								res.message,
								"",
								res.icon
							)
						});
					}
					this.getEventDropdowns();
				});
			},
			deleteNominee(item) {
				Swal.fire({
					title: "Delete Nominee",
					text: `Are you sure you want to delete`,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '397373',
					cancelButtonColor:'grey',
					confirmButtonText: 'Yes, delete it!',
					reverseButtons:true,
				}).then((result) => {
					if (result.isConfirmed) {
						let payload = {
							url: 'delete-nominee', 
							id: item.id,
							event_id: this.GET_EVENT_ID
						};
						this.$store.dispatch('urlDelete', payload).then((response) => {
							Swal.fire(
								'Deleted!',
								`${item.full_name} has been deleted.`,
								'success'
							);
						}).catch((error) => {
							Swal.fire(
								'Error!',
								'There was an error deleting the nominee.',
								'error'
							);
						});
					}
				});
			},
			deleteEmployee(item) {
				const guestId = item.id;
				const employee_id = item.employee_id;
				const id = item.id;
				let swalConfig = {
					title: "Delete Guest",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#397373',
					cancelButtonColor: 'grey',
					confirmButtonText: 'Yes, delete it!',
					reverseButtons: true,
				};
				if (item.nominated) {
					swalConfig.text = "This guest is nominated. Deleting this guest will remove their nomination. Are you sure?";
				} else {
					swalConfig.text = "Are you certain you want to remove this guest?";
				}
				Swal.fire(swalConfig).then((result) => {
					if (result.isConfirmed) {
						let payload = {
							url: 'deleteGuest',
							guest_id: guestId,
							id: id,
							event_id: this.GET_EVENT_ID,
						};
						this.$store.dispatch('urlDelete', payload).then(() => {
							Swal.fire(
								'Deleted!',
								`${item.full_name || 'Guest'} has been deleted successfully.`,
								'success'
							);
							// this.items = this.items.filter(guest => guest.id !== guestId);
						}).catch((error) => {
							const errorMessage = error.response && error.response.data && error.response.data.message
								? error.response.data.message
								: 'There was an error deleting the guest.';
							Swal.fire(
								'Error!',
								errorMessage,
								'error'
							);
						});
					}
				});
			},
			orderDialog(value){
				if(value){
                    if(this.tab.index == 2){
                        this.draggable_items = this.dropdowns.raffle_list_all;
                        // Initialize priority raffles from existing data (include all priority raffles, even drawn ones)
                        this.priorityRafflePrizes = this.dropdowns.raffle_list_all
                            .filter(item => item.priority == 1 || item.priority === true)
                            .map(item => item.id);
                    }else{
                        this.draggable_items = this.items;
                        this.priorityRafflePrizes = [];
                    }
				} else {
					this.priorityRafflePrizes = [];
				}
				this.orderPrizeDialog = value;
			},
			isRaffleDrawn(item) {
				// Disable selection if raffle has been drawn
				return item.raffle_drawn == 1;
			},
			removePriorityRaffle(raffleId) {
				// Check if raffle has been drawn
				const raffle = this.draggable_items.find(item => item.id === raffleId);
				if (raffle && raffle.raffle_drawn == 1) {
					Swal.fire({
						title: 'Cannot Remove',
						text: 'This raffle has already been drawn and cannot be removed from priority list.',
						icon: 'warning',
						confirmButtonText: 'OK'
					});
					return;
				}
				// Remove raffle from priority list
				this.priorityRafflePrizes = this.priorityRafflePrizes.filter(id => id !== raffleId);
				// Clear priority_order for removed raffle
				const removedRaffle = this.draggable_items.find(item => item.id === raffleId);
				if (removedRaffle) {
					removedRaffle.priority_order = null;
				}
				// Reorder remaining priority raffles
				this.selectedPriorityRaffles.forEach((item, index) => {
					const originalItem = this.draggable_items.find(orig => orig.id === item.id);
					if (originalItem) {
						originalItem.priority_order = index + 1;
					}
				});
			},
			checkPriorityMove(evt) {
				// Prevent moving items that have been drawn (have winners)
				const draggedItem = this.selectedPriorityRaffles[evt.draggedContext.index];
				if (draggedItem && draggedItem.raffle_drawn == 1) {
					return false;
				}
				return true;
			},
			updatePriorityOrder() {
				// Update priority_order for all priority raffles based on their new position
				this.selectedPriorityRaffles.forEach((item, index) => {
					const originalItem = this.draggable_items.find(orig => orig.id === item.id);
					if (originalItem) {
						originalItem.priority_order = index + 1;
					}
				});
			},
			onPriorityRafflesChange() {
				// Assign priority_order to newly added priority raffles
				this.selectedPriorityRaffles.forEach((item, index) => {
					if (!item.priority_order || item.priority_order === null) {
						const originalItem = this.draggable_items.find(orig => orig.id === item.id);
						if (originalItem) {
							// Find the highest existing priority_order and add 1, or use index + 1
							const maxPriorityOrder = Math.max(
								...this.selectedPriorityRaffles
									.map(p => p.priority_order)
									.filter(o => o !== null && o !== undefined),
								0
							);
							originalItem.priority_order = maxPriorityOrder + 1;
						}
					}
				});
				// Re-sort to maintain order
				this.updatePriorityOrder();
			},
			getPriorityTableRowStyle(item) {
				let defaultStyle = 'cursor:move'
				// Disable dragging if raffle has been drawn (has winner)
				if (item.raffle_drawn == 1) {
					defaultStyle = defaultStyle.concat(';pointer-events:none;opacity:0.6')
				}
				return defaultStyle;
			},
			saveOrder(){
				
				// Update order for non-priority items only
				this.nonPriorityRaffleItems.forEach((x, i) => {
					x.order = i + 1;
					delete x.prize_image;
				});
				
				// Build priority_orders object mapping raffle ID to priority_order
				const priorityOrders = {};
				this.selectedPriorityRaffles.forEach((item, index) => {
					priorityOrders[item.id] = index + 1;
				});
				
				// Combine all items for saving (both priority and non-priority)
				const allItems = [...this.selectedPriorityRaffles, ...this.nonPriorityRaffleItems];
				
				let payload = {
					url: 'orderRafflePrizes',
					items: allItems,
					priority_prizes: this.priorityRafflePrizes,
					priority_orders: priorityOrders,
					event_id: this.GET_EVENT_ID
				}
				this.$store.dispatch('urlPost', payload).then((response)=>{
					this.$store.commit('NEW_MASTER_DATA', true)
					Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
				    this.orderDialog(false);

				})
			},
			getTableRowStyle(item) {
				let defaultStyle = 'cursor:move'
				// Disable dragging if raffle has been drawn (has winner)
				if (item.raffle_drawn == 1) {
					defaultStyle = defaultStyle.concat(';pointer-events:none;opacity:0.6')
				}
				// Keep existing logic for other cases
				if (item.title == 'National Manager' || item.title == 'Salesman' || item.title == 'Sales Coordinator') {
					defaultStyle = defaultStyle.concat(';pointer-events:none')
				}
				return defaultStyle;
			},
			checkMove(evt) {
				// Prevent moving items that have been drawn (have winners)
				const draggedItem = this.nonPriorityRaffleItems[evt.draggedContext.index];
				if (draggedItem && draggedItem.raffle_drawn == 1) {
					return false;
				}
				return true;
			},
			tableRowStyle(title) {
				let defaultStyle = 'cursor:move'
				if (title == 'National Manager' || title == 'Salesman' || title == 'Sales Coordinator') {
					defaultStyle = defaultStyle.concat(';pointer-events:none')
				}
				return defaultStyle;
			},
			flowDialogTrigger(value){
				if(value){
					this.draggable_items = this.items;
				}
				this.flowDialog = value;
			},
			saveFlowOrder(){
				this.flowDialogTrigger(false);
				this.draggable_items.forEach((x,i) =>{
					x.order = i + 1
					delete x.prize_image
				})
				let payload = {
					url: 'orderFlowImages',
					items: this.draggable_items,
					event_id: this.GET_EVENT_ID
				}
				this.$store.dispatch('urlPost', payload).then((response)=>{
					this.$store.commit('NEW_MASTER_DATA', true)
					Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
				})
			},
			generateReference() {
				let payload = {
					url: "generate-reference-num",
				};
				try {
					this.$store.dispatch("urlGet", payload)
					.then(response => {
						let generatedReference = response.generated_reference;
						this.generatedref = generatedReference;
					});
				} catch (error) {
					console.error(error);
				}
			},
			validateForm(action, item = {}) {
				if(action == 'add'){
					if (
						!this.addParticipantLastName ||
						!this.addParticipantFirstName ||
						!this.addParticipantCompanyID ||
						!this.addParticipantGender
					) {
						return true; 
					}
					return false;
				}else{
					if(
						!item.company_id ||
						!item.gender	 ||
						!item.first_name ||
						!item.last_name
					){
						return true
					}else{
						return false;
					}
				}
			},
			resetFields(){
				this.addParticipantReference = '';
				this.addParticipantFirstName = '';
				this.addParticipantLastName = '';
				this.addParticipantMiddleName = '';
				this.addParticipantTableNumber = '';
				this.addParticipantCompanyID = '';
				this.addParticipantBuffetNumber = '';
				this.addParticipantMobileBarTicket = '';
				this.addParticipantIncludeRaffle = 0;
				this.addParticipantGender = '';
				this.addDepartmentID = '';
				this.addTenureCode = '';
			},
			getCompanyDropdowns(){
				let payload = {
					url: 'companyRoute'
				}
				this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.company_list = res.data
				});
			},
			async getEventDropdowns(){
				let payload = {
					url: 'eventDetailDropdown'
				}
				await this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.event_list = res.data
				});
			},
			
			async downloadCompaniesExcel() {
                Swal.fire({
                    title: 'Exporting Data...',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
                Swal.showLoading();
				let payload = {
					url: "companyExcel",
				};
				try {
					await this.$store.dispatch("urlPost", payload).then((response) => {
						let data = response;
						let wb = XLSX.utils.book_new();
						let ws_detailed = XLSX.utils.json_to_sheet(data.detailed);
						this.autoFitColumns(ws_detailed, data.detailed);
						XLSX.utils.book_append_sheet(wb, ws_detailed, 'Detailed');
						let ws_summary = XLSX.utils.json_to_sheet(data.summary);
						this.autoFitColumns(ws_summary, data.summary);
						XLSX.utils.book_append_sheet(wb, ws_summary, 'Summary');
						let excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
						let blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
						let url = window.URL.createObjectURL(blob);
						let link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `${this.GET_EVENT_NAME.replace(" ", "").toUpperCase()}_Official_Companies.xlsx`);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);

						this.downloadCompanyDialog = false;
						Swal.close();
						Swal.fire({
							title: "Check your Downloads!",
							text: "Data Downloaded Successfully!",
							icon: "success",
							allowOutsideClick: false,
							customClass: {
								confirmButton: 'orange-button',
							},
						});
					});
				} catch (error) {
                    Swal.close()
					console.error(error);
				}
			},
			autoFitColumns(worksheet, jsonData) {
				const colWidths = [];
				for (const colName of Object.keys(jsonData[0] || {})) {
					const maxLength = Math.max(
						...jsonData.map(row => (row[colName] ? row[colName].toString().length : 0)),
						colName.length
					);
					colWidths.push({ wch: maxLength + 2 });
				}
				worksheet['!cols'] = colWidths;
			},

			changeNomineeTab(gender){
				let payload = {
					gender: gender
				}
				this.getTableData(5, payload);
				this.$store.commit('GENDER', gender);
			},
			logout(){
				let payload = {
					url: 'logout'
				}
				this.$store.dispatch("urlPost", payload).then(() => {
					localStorage.removeItem("token");
					localStorage.removeItem("otherData");
					window.location.reload();
				});
			},
			toggleStatus(item, status){
                if (status == 1) {
                    Swal.fire({
                        title: 'Enter override password',
                        input: 'password',
                        inputLabel: 'Override Password',
                        inputPlaceholder: 'Enter password',
                        inputAttributes: {
                            maxlength: 20,
                            autocapitalize: 'off',
                            autocorrect: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText: 'Submit',
                        preConfirm: (password) => {
                            if (!password) {
                                Swal.showValidationMessage('Password is required');
                            }
                            return password;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            let enteredPassword = result.value;
                            let payload = {
                                url: "checkOverridePassword",
                                password: enteredPassword
                            };

                            // Show loading dialog
                            Swal.fire({
                                title: 'Verifying Password...',
                                allowOutsideClick: false,
                                showConfirmButton: false,
                                didOpen: () => {
                                    Swal.showLoading();
                                }
                            });

                            this.$store.dispatch('urlPost', payload).then(response => {
                                Swal.close(); // Close loading

                                if (!response.valid) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Incorrect Password',
                                        text: 'Access denied.',
                                    });
                                    return false;
                                } else {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Success',
                                        text: '',
                                        timer: 1000,
                                        showConfirmButton: false
                                    });

                                    if (status === 1 && item.status_id !== 1) {
                                        this.totals.total_attended = Math.max(0, this.totals.total_attended - 1);
                                        this.totals.total_unattended = Math.max(0, this.totals.total_unattended + 1);
                                        this.totals.total_attended_percent = (
                                            (this.totals.total_attended / this.totals.total_pax) * 100
                                        ).toFixed(2);
                                    } else if (status === 2 && item.status_id !== 2) {
                                        this.totals.total_attended = Math.max(0, this.totals.total_attended + 1);
                                        this.totals.total_unattended = Math.max(0, this.totals.total_unattended - 1);
                                        this.totals.total_attended_percent = (
                                            (this.totals.total_attended / this.totals.total_pax) * 100
                                        ).toFixed(2);
                                    }

                                    item.status_id = status;
                                    item.time_in = status == 1 ? null : moment().format('YYYY-MM-DD HH:mm:ss');

                                    let updatePayload = {
                                        url: 'changeParticipantStatus',
                                        id: item.id,
                                        status_id: status
                                    };

                                    this.$store.dispatch('urlPost', updatePayload);
                                }
                            });
                        }
                    });
                }else{
                    if (status === 1 && item.status_id !== 1) {
                        this.totals.total_attended = Math.max(0, this.totals.total_attended - 1);
                        this.totals.total_unattended = Math.max(0, this.totals.total_unattended + 1);
                        this.totals.total_attended_percent = (this.totals.total_attended / this.totals.total_pax * 100).toFixed(2) ;
                    } else if (status === 2 && item.status_id !== 2) {
                        this.totals.total_attended = Math.max(0, this.totals.total_attended + 1);
                        this.totals.total_unattended = Math.max(0, this.totals.total_unattended - 1);
                        this.totals.total_attended_percent = (this.totals.total_attended / this.totals.total_pax * 100).toFixed(2)
                    }
                    item.status_id = status;
                    item.time_in = status == 1 ? null : moment().format('YYYY-MM-DD HH:mm:ss');
                    let payload = {
                        url: 'changeParticipantStatus',
                        id: item.id,
                        status_id: status
                    }
                    this.$store.dispatch('urlPost', payload)
                }
			},
			async setDefaultFilter(){
				Object.assign(this.filters,{
					status: this.defaults.status
				})
				this.$store.commit('EVENT_ID', this.defaults.event_id)
				this.$store.commit('EVENT_NAME', this.dropdowns.event_list.find(x => this.defaults.event_id == x.id)?.name)
			},
			selectEvent(event_id,event_name){
				document.title = event_name; 
				this.$store.commit('EVENT_ID', event_id);
				this.$store.commit('EVENT_NAME', event_name);
			},
			async getGroupingSettings(){
				let payload = {
					type: 'Expansions',
					url: 'moduleSettings',
					event_id: this.GET_EVENT_ID
				};
				await this.$store.dispatch("urlGet", payload).then((res)=>{
					res.forEach(e=>{
						Object.keys(this.settings).filter(el=>{
							if(el == e.parameter){
								this.settings[el] = parseFloat(e.value)
							}
						});
					})
				})
			},
			encodeBase64(value) {
				return btoa(value); 
			},
			dragover(e) {
				e.preventDefault();
				this.isDragging = true;
			},
			dragleave() {
				this.isDragging = false;
			},
			drop(e) {
				e.preventDefault();
				this.$refs.file.files = e.dataTransfer.files;
				this.ImportedExcel();
				this.isDragging = false;
			},
			ImportedExcel(event) {
				this.loaded = false;
				let that = this;
				that.file = that.$refs.file.files[0];
				let fileReader = new FileReader();
				let seenEntries = new Set();
				let seenNames = new Set();

				setTimeout(() => {
					fileReader.readAsArrayBuffer(that.file);
					that.loading_text = "Transferring data, please wait...";

					fileReader.onload = () => {
						that.arrayBuffer = fileReader.result;
						let data = new Uint8Array(that.arrayBuffer);
						let arr = [];

						for (let i = 0; i < data.length; i++) {
							arr[i] = String.fromCharCode(data[i]);
						}

						let bstr = arr.join("");
						let workbook = XLSX.read(bstr, { type: "binary" });
						let worksheet = workbook.Sheets[workbook.SheetNames[0]];
						let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

						that.filelist = [];
						that.batchAdditionItems = []; 

						arraylist.forEach((row) => {
							let firstName = String(row["FIRST NAME"] || "").trim().toLowerCase();
							let lastName = String(row["LAST NAME"] || "").trim().toLowerCase();
							let middleName = String(row["MIDDLE NAME"] || "").trim().toLowerCase();
							let employeeID = String(row["EMPLOYEE ID"] || "").trim();

							let key = `${employeeID}_${firstName}_${middleName}_${lastName}`;
							if (seenEntries.has(key)) {
								return; 
							}

							seenEntries.add(key);

							let nameKey = `${firstName} ${middleName} ${lastName}`.trim();
							if (seenNames.has(nameKey)) {
								return; 
							}

							seenNames.add(nameKey);

							if (that.settings.data_grouping == 1) {
								that.batchAdditionItems.push({
									employee_id: employeeID,
									company_name: row["COMPANY NAME"] || "",
									last_name: row["LAST NAME"] || "",
									first_name: row["FIRST NAME"] || "",
									middle_name: row["MIDDLE NAME"] || "",
									department_name: row["DEPARTMENT"] || "",
									buffet_num: row["BUFFET #"] || "",
									tenure_code: row["TENURE CODE"] || "",
									gender: row["GENDER"] || "",
									table: row["TABLE"] || "",
									unique_code: row["UNIQUE CODE"] || null,
								});
							} else {
								that.batchAdditionItems.push({
									company_name: row["COMPANY"] || "",
									last_name: row["LAST NAME"] || "",
									first_name: row["FIRST NAME"] || "",
									middle_name: row["MIDDLE NAME"] || "",
									gender: row["GENDER"] || "",
									table: row["TABLE"] || "",
									unique_code: row["UNIQUE CODE"] || null,
								});
							}
						});

						that.loaded = true;
						that.loading_text = "Loading... Please Wait";
					};
				}, 2000);
			},
			submitImport() {
				this.loading.button = true;
				let payload = {
					url: 'importGuestsFromExcel',
					items: this.batchAdditionItems,
					event_id: this.GET_EVENT_ID,
				};

				this.$store.dispatch('urlPost', payload).then((res) => {
					this.loading.button = false;
					Swal.fire(res.icon.toUpperCase(), res.message, res.icon);
					this.$store.commit('NEW_MASTER_DATA', true);
					this.uploadParticipantsDialog = false;

					if (res.existing_guests.length > 0) {
						Swal.fire({
							title: 'Duplicate Entries Detected!',
							html: `<div class="swal-subtitle">
									The following guests already exist in the system:
								</div>
								<div class="swal-scrollable-content">
									<ul>
									${res.existing_guests.map((guest) => `<li>${guest}</li>`).join('')}
									</ul>
								</div>`,
							allowOutsideClick: false,
							icon: 'warning',
							scrollbarPadding: false,
							customClass: {
								popup: 'custom-swal-popup',
								title: 'custom-swal-title',
								htmlContainer: 'custom-swal-html',
							},
						});
						return false;
					}
				}).catch((error) => {
					this.loading.button = false;
					if (error.response) {
						if (error.response.status == 401) {
							Swal.fire({
								title: 'Unauthenticated!',
								text: '',
								icon: 'error',
								allowOutsideClick: false,
							}).then((result) => {
								if (result.isConfirmed) {
									localStorage.removeItem("token");
									window.location.reload();
									this.$router.push('/');
								}
							});
						}
					} else {
						console.log(error);
					}
				});
			},
			downloadImportTemplate() {
				let wb = XLSX.utils.book_new(); 
				let guestData = null; 
				let companyData = null; 
				let filename = ' Guest Import Template.xlsx'; 

				if (this.settings.data_grouping == 1) {
					guestData = [{
						['EMPLOYEE ID']: null,
						['COMPANY NAME']: null,
						['LAST NAME']: null,
						['FIRST NAME']: null,
						['MIDDLE NAME']: null,
						['DEPARTMENT']: null,
						['BUFFET #']: null,
						['TENURE CODE']: null,
						['GENDER']: null,
						['TABLE']: null,
					}];
				} else {
					companyData = [{
						['COMPANY']: null,
						['LAST NAME']: null,
						['FIRST NAME']: null,
						['MIDDLE NAME']: null,
						['GENDER']: null,
						['TABLE']: null,
						['UNIQUE CODE']: null,
					}];
					filename = 'Company Import Template.xlsx';
				}

				if (guestData) {
					let guestSheet = XLSX.utils.json_to_sheet(guestData);
					XLSX.utils.book_append_sheet(wb, guestSheet, 'Guests');
				}

				if (companyData) {
					let companySheet = XLSX.utils.json_to_sheet(companyData);
					XLSX.utils.book_append_sheet(wb, companySheet, 'Company');
				}

				let excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
				let blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename); 
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			rafflePrizeDragover(e) {
				e.preventDefault();
				this.rafflePrizeHaveImg = true;
			},
			rafflePrizeDragleave() {
				this.rafflePrizeHaveImg = false;
			},
			rafflePrizeDrop(e) {
				e.preventDefault();
				if (e.dataTransfer?.files?.length) {
					this.$refs.rafflePrizeFile.files = e.dataTransfer.files;
					this.rafflePrizeUploadedFile = e.dataTransfer.files[0];
					this.importRafflePrizeExcel();
				}
				this.rafflePrizeHaveImg = false;
			},
			async importRafflePrizeExcel(event) {
				this.rafflePrizeLoaded = false;
				const file = event?.target?.files?.[0] || this.$refs.rafflePrizeFile?.files?.[0];
				if (!file) {
					this.rafflePrizeLoaded = true;
					return;
				}
				this.rafflePrizeUploadedFile = file;
				this.rafflePrizeLoadingText = 'Transferring data, please wait...';
				try {
					const buffer = await file.arrayBuffer();
					const workbook = new ExcelJS.Workbook();
					await workbook.xlsx.load(buffer);
					const worksheet = workbook.worksheets[0];
					if (!worksheet) {
						throw new Error('No worksheet found in the uploaded file.');
					}

					const imageMap = this.extractExcelImages(workbook, worksheet);
					const existingOrders = (this.dropdowns?.raffle_list_all || [])
						.map(item => Number(item.order))
						.filter(order => Number.isInteger(order) && order > 0);
					let maxOrder = existingOrders.length ? Math.max(...existingOrders) : 0;
					const usedOrders = new Set(existingOrders);

					const parsedRows = [];
					worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
						if (rowNumber === 1) {
							return;
						}

						const code = (row.getCell(2).text || '').trim();
						const name = (row.getCell(3).text || '').trim();
						const tenureRaw = (row.getCell(4).text || '').trim();
						const winnerCountRaw = row.getCell(5).value;
						const orderRaw = row.getCell(6).value;
						const batchRaw = row.getCell(7).value;
						const suspenseRaw = row.getCell(8).value;

						let order = parseInt(orderRaw, 10);
						order = Number.isInteger(order) && order > 0 ? order : null;
						if (order && usedOrders.has(order)) {
							order = ++maxOrder;
						} else if (!order) {
							order = ++maxOrder;
						} else if (order > maxOrder) {
							maxOrder = order;
						}
						usedOrders.add(order);

						const winnerCount = Number.isInteger(parseInt(winnerCountRaw, 10)) && parseInt(winnerCountRaw, 10) > 0
							? parseInt(winnerCountRaw, 10)
							: 1;
						const batch = Number.isInteger(parseInt(batchRaw, 10)) && parseInt(batchRaw, 10) > 0
							? parseInt(batchRaw, 10)
							: 1;
						const suspense_animate = Number(suspenseRaw) === 1 ? 1 : 0;

						const explicitImageValue = row.getCell(1).value;
						let inlineBase64 = '';
						if (typeof explicitImageValue === 'string' && explicitImageValue.startsWith('data:image')) {
							inlineBase64 = explicitImageValue.trim();
						}
						const imageInfo = imageMap.get(rowNumber);
						const imageBase64 = (imageInfo && imageInfo.dataUrl) || inlineBase64;
						const hasEmbeddedImage = Boolean(imageInfo && imageInfo.hasImage);

						parsedRows.push({
							image_base64: imageBase64 || '',
							image_path: imageBase64 || '',
							has_embedded_image: hasEmbeddedImage,
							code,
							name,
							tenure_categories: tenureRaw,
							winner_count: winnerCount,
							order,
							batch,
							suspense_animate
						});
					});

					const processedRows = [];
					for (const row of parsedRows) {
						if (row.image_base64 && row.image_base64.startsWith('data:image')) {
							try {
								const transparentImage = await this.removeImageBackground(row.image_base64);
								row.image_base64 = transparentImage;
								row.image_path = transparentImage;
							} catch (error) {
								console.error('Failed to remove image background', error);
							}
						}
						processedRows.push(row);
					}
					this.batchRafflePrizeItems = processedRows;
					this.uploadRafflePrizesFilterIncomplete = false;
					const rowsMissingImages = this.batchRafflePrizeItems
						.filter(item => !this.itemHasImage(item))
						.map(item => item.name || item.code || 'Unnamed Prize');
					if (rowsMissingImages.length) {
						Swal.fire({
							title: 'Missing Images Detected',
							html: `<div style="text-align:left;">The following prize(s) doesn't have images:<br><strong>${rowsMissingImages.join(', ')}</strong></div>`,
							icon: 'warning'
						});
					}
					this.rafflePrizeLoaded = true;
					this.rafflePrizeLoadingText = '';

					if (!parsedRows.length) {
						Swal.fire('No Data', 'No raffle prize rows found in the worksheet.', 'warning');
					}
				} catch (error) {
					console.error(error);
					this.rafflePrizeLoaded = true;
					this.rafflePrizeLoadingText = '';
					Swal.fire('Import Error', error.message || 'Unable to parse the provided file. Please ensure it matches the template.', 'error');
				}
			},
			async submitRafflePrizeImport() {
				for (const item of this.batchRafflePrizeItems) {
					if (item.image_base64 && item.image_base64.startsWith('data:image')) {
						try {
							const transparentImage = await this.removeImageBackground(item.image_base64);
							item.image_base64 = transparentImage;
							item.image_path = transparentImage;
						} catch (error) {
							console.error('Failed to remove image background', error);
						}
					}
				}
				const errors = [];
				this.batchRafflePrizeItems.forEach((item, idx) => {
					const label = this.getRaffleItemLabel(item, idx);
					if (!this.itemHasImage(item)) {
						errors.push(`${label}: Image is required`);
					}
					if (!item.code || item.code.trim() === '') {
						errors.push(`${label}: Code is required`);
					}
					if (!item.name || item.name.trim() === '') {
						errors.push(`${label}: Name is required`);
					}
					if (item.winner_count && (isNaN(item.winner_count) || item.winner_count < 1)) {
						errors.push(`${label}: Winner Count must be a positive number`);
					}
					if (item.order && (isNaN(item.order) || item.order < 1)) {
						errors.push(`${label}: Order must be a positive number`);
					}
					if (item.batch && (isNaN(item.batch) || item.batch < 1)) {
						errors.push(`${label}: Batch must be a positive number`);
					}
				});
				if (errors.length) {
					Swal.fire({
						title: 'Validation Errors',
						html: `<div style="text-align:left;"><ul>${errors.map(err => `<li>${err}</li>`).join('')}</ul></div>`,
						icon: 'error'
					});
					return;
				}
				if (this.batchRafflePrizeItems.length === 0) {
					Swal.fire('No Data', 'Please import raffle prize data before submitting.', 'warning');
					return;
				}
				this.loading.button = true;
				const payload = {
					url: 'importRafflePrizesFromExcel',
					event_id: this.GET_EVENT_ID,
					items: this.batchRafflePrizeItems.map(item => ({
						image_base64: item.image_base64,
						image_path: item.image_path,
						has_embedded_image: item.has_embedded_image,
						code: item.code,
						name: item.name,
						tenure_categories: item.tenure_categories,
						winner_count: item.winner_count,
						order: item.order,
						batch: item.batch,
						suspense_animate: item.suspense_animate
					}))
				};
				try {
					const data = await this.$store.dispatch('urlPost', payload);
					Swal.fire(data.icon?.toUpperCase?.() || 'SUCCESS', data.message || 'Raffle prizes imported successfully.', data.icon || 'success');
					this.$store.commit('NEW_MASTER_DATA', true);
					this.uploadRafflePrizesDialog = false;
					this.batchRafflePrizeItems = [];
					this.rafflePrizeUploadedFile = null;
					if (this.$refs.rafflePrizeFile) {
						this.$refs.rafflePrizeFile.value = '';
					}
					this.getTableData(2);
				} catch (error) {
					const response = error.response?.data;
					const message = response?.message || 'An unexpected error occurred while importing.';
					Swal.fire('Import Error', message, 'error');
				} finally {
					this.loading.button = false;
				}
			},
			async downloadRafflePrizeTemplate() {
				const wb = XLSX.utils.book_new();
				// Tiny embedded PNG (1x1) to demonstrate image import without large file size
				const sampleImageBase64 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+7x4kAAAAASUVORK5CYII=';
				const base64ToUint8Array = (b64) => {
					const binary = atob(b64);
					const len = binary.length;
					const bytes = new Uint8Array(len);
					for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
					return bytes;
				};
				const sampleData = [{
					IMAGE: 'Paste image here (Right-click cell > Insert > Picture)',
					CODE: 'PRIZE001',
					NAME: 'Sample Prize',
					'TENURE CATEGORIES': 'A,B',
					'WINNER COUNT': 1,
					ORDER: 1,
					BATCH: 1,
					'SUSPENSE ANIMATE': 0
				}];
				const sheet = XLSX.utils.json_to_sheet(sampleData);
				sheet['!cols'] = [
					{ wch: 35 },
					{ wch: 18 },
					{ wch: 30 },
					{ wch: 25 },
					{ wch: 15 },
					{ wch: 10 },
					{ wch: 10 },
					{ wch: 18 }
				];
				// Anchor example image at A2
				sheet['!images'] = [{
					name: 'sample.png',
					type: 'image/png',
					data: base64ToUint8Array(sampleImageBase64),
					position: { tl: { row: 1, col: 0 } }
				}];
				XLSX.utils.book_append_sheet(wb, sheet, 'Raffle Prizes');
				const instructions = [
					['Raffle Prize Import Instructions'],
					[''],
					['Columns'],
					['Image', 'Paste the actual image into the IMAGE cell (Right-click > Insert > Picture).'],
					['Code', 'Required unique code per prize.'],
					['Name', 'Required name of the prize.'],
					['Tenure Categories', 'Comma-separated list (e.g., A,B,C).'],
					['Winner Count', 'Defaults to 1 if empty.'],
					['Order', 'Display order, optional.'],
					['Batch', 'Defaults to 1 if empty.'],
					['Suspense Animate', '0 or 1.']
				];
				const instructionSheet = XLSX.utils.aoa_to_sheet(instructions);
				instructionSheet['!cols'] = [{ wch: 80 }];
				XLSX.utils.book_append_sheet(wb, instructionSheet, 'Instructions');
				const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'Raffle_Prize_Import_Template.xlsx');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			redirectToEvent(){
				let payload = {
					event_id: this.GET_EVENT_ID,
					url: 'getEventMD5'
				}
				this.$store.dispatch('urlPost', payload).then((res)=>{
					window.open(`${process.env.VUE_APP_API_HOST_CLIENT}?ec=${res.link}`)
				})
			},
			filterCompanyByTicket() {
				let ticket_num_search = this.filterValue.ticket_num ? this.filterValue.ticket_num.toLocaleLowerCase() : null;
				let company_list = this.items;

				if(ticket_num_search) {
					let filtered_company_by_ticket = company_list.filter(e => {
						let ticket_nums = e.company_tickets.filter(el => el.included_in_raffle == 1).map(x => x.ticket_num.toLocaleLowerCase());
						return ticket_nums.some(num => num.includes(ticket_num_search));
					});

					this.company_items = filtered_company_by_ticket;
				} else {
					this.company_items = this.items;
				}
			},
			getDepartments(){
				let payload = {
					url: 'getDepartments'
				}
				this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.department_list = res
				});
			},
			getTenureCategory(){
				let payload = {
					url: 'getTenureCategory'
				}
				this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.tenure_list = res
				});
			},
			getBuffetTableList(){
				let payload = {
					url: 'getBuffetTableList'
				}
				this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.buffet_table_list = res
				});
			},
			async downloadRafflePrize() {
                Swal.fire({
                    title: 'Exporting Data...',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
                Swal.showLoading();
				let payload = {
					url: "downloadRafflePrize",
				};
				try {
					const response = await this.$store.dispatch("urlGet", payload);
					if (!response || !response.combined_data) {
						Swal.fire({
							title: "Error",
							text: "Unexpected response format. Please check the data.",
							icon: "error",
							allowOutsideClick: false,
							customClass: {
								confirmButton: "orange-button",
							},
						});
						return;
					}
					let headers = [];
					let processedData = [];
					if (response.combined_data.length > 0) {
						const firstItem = response.combined_data[0];
						if (firstItem["Guest Name"] !== undefined) {
							headers = ["Order","Raffle Prize Name", "Reference#", "Guest Name"];
							processedData = response.combined_data.map((item) => ({
								"Order": item["Order"] || "N/A", 
								"Raffle Prize Name": item["Raffle Name"] || "N/A", 
								"Reference#": item["Reference#"] || "N/A",
								"Guest Name": item["Guest Name"] || "N/A",
							}));
						} else if (firstItem["Company Name"] !== undefined) {
							headers = ["Order","Raffle Prize Name", "Ticket#", "Company Name"]; 
							processedData = response.combined_data.map((item) => ({
								"Order": item["Order"] || "N/A",
								"Raffle Prize Name": item["Raffle Name"] || "N/A", 
								"Ticket#": item["Ticket#"] || "N/A",
								"Company Name": item["Company Name"] || "N/A",
							}));
						}
					}
					let wb = XLSX.utils.book_new();
					let ws = XLSX.utils.aoa_to_sheet([headers]);
					XLSX.utils.sheet_add_aoa(ws, processedData.map((row) => headers.map((header) => row[header])), {
						origin: "A2",
					});
					ws["!cols"] = headers.map((header) => {
						const maxLength = Math.max(
							header.length,
							...processedData.map((row) => (row[header] ? row[header].toString().length : 0))
						);
						return { width: maxLength + 2 };
					});
					XLSX.utils.book_append_sheet(wb, ws, "Raffle Winners");
					const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
					const blob = new Blob([s2ab(excelBuffer)], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					});
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						`${this.GET_EVENT_NAME.replace(/\s+/g, "").toUpperCase()}_Raffle_Winners_Data.xlsx`
					);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.downloadCompanyDialog = false;
                    Swal.close();
					Swal.fire({
						title: "Check your Downloads!",
						text: "Data downloaded successfully!",
						icon: "success",
						allowOutsideClick: false,
						customClass: {
							confirmButton: "orange-button",
						},
					});
				} catch (error) {
                    Swal.close();
					Swal.fire({
						title: "Error",
						text: "Failed to download the data. Please try again.",
						icon: "error",
						allowOutsideClick: false,
						customClass: {
							confirmButton: "orange-button",
						},
					});
				}
				function s2ab(s) {
					const buf = new ArrayBuffer(s.length);
					const view = new Uint8Array(buf);
					for (let i = 0; i < s.length; i++) {
						view[i] = s.charCodeAt(i) & 0xff;
					}
					return buf;
				}
			},
			onPaginationChange(options) {
				this.pagination.page = options.page;
				this.pagination.itemsPerPage = options.itemsPerPage;
				this.getTableData(this.current_index);
			},
			getScreenHeight(){
				this.screenHeight = window.innerHeight;
				return window.innerHeight
			},
			updateHeight() {
				this.$forceUpdate(); 
			},
			resetPagination(){
				this.pagination.page = 1;
				this.pagination.itemsPerPage = 10;
			},
            async generatePDF(by_company = 0, item = null, multiple_guest = false, zipped_per_guest = 0) {
                if (by_company) {
                    this.loading.generatePDF = true;

                    const zip = new JSZip();
                    const totalCompanies = this.dropdowns.company_list.length;
                    let currentIndex = 0;

                    Swal.fire({
                        title: 'Generating PDFs',
                        html: 'Starting...',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    for (const company of this.dropdowns.company_list) {
                        currentIndex++;

                        const percent = Math.round((currentIndex / totalCompanies) * 100);

                        Swal.update({
                            html: `
                                <div style="font-size: 16px;">
                                    <div class="swal2-loader" style="margin-bottom: 15px;"></div>
                                    Processing: <b>${company.name}</b><br>
                                    Progress: <b>${percent}%</b> (${currentIndex} of ${totalCompanies})
                                </div>
                            `
                        });

                        let payload = {
                            url: 'getGuestUniqueCode',
                            company_id: company.id,
                            by_company: by_company
                        };

                        const doc = new jsPDF();
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const margin = 10;
                        let isFirstPage = true;

                        await this.$store.dispatch("urlPost", payload).then(async (response) => {
                            for (const guest of response) {
                                if (!isFirstPage) doc.addPage();
                                isFirstPage = false;

                                const maxWidth = pageWidth - 40; // 20 padding on each side
                                const fontSize = 19;

                                doc.setFontSize(fontSize);
                                doc.setFont('Helvetica', 'bold');

                                const textWidth = doc.getTextWidth(company.name);

                                // Check if the text fits within the maxWidth
                                if (textWidth <= maxWidth) {
                                    // Fits in one line, center it
                                    doc.text(company.name, pageWidth / 2, 20, { align: 'center' });
                                } else {
                                    // Too long, wrap to next line
                                    const lines = doc.splitTextToSize(company.name, maxWidth);
                                    doc.text(lines, pageWidth / 2, 20, { align: 'center' });
                                }
                                const qrDataUrl = await QRCode.toDataURL(guest.unique_code, {
                                    width: 500,
                                    margin: 1
                                });

                                const imageWidth = this.qr_code.width;
                                const imageHeight = this.qr_code.height;
                                const x = (pageWidth - imageWidth) / 2;
                                const y = this.qr_code.start_y;

                                doc.addImage(qrDataUrl, 'PNG', x, y, imageWidth, imageHeight);

                                doc.setFontSize(18);
                                doc.setFont('Helvetica', 'bold');
                                const guestName = `GUEST NAME: ${guest.full_name || "N/A"}`;
                                const tableNum = `Table#: ${guest.table_num || "N/A"}`;
                                const uniqueCode = `UNIQUE CODE: ${guest.unique_code}`;
                                
                                doc.text(guestName, pageWidth / 2, y + imageHeight + 25, { align: 'center' });
                                doc.text(tableNum, pageWidth / 2, y + imageHeight + 35, { align: 'center' });
                                doc.text(uniqueCode, pageWidth / 2, y + imageHeight + 45, { align: 'center' });
                            }
                        });

                        const safeName = company.name.replace(/[\\/:*?"<>|]/g, "_");
                        const pdfBlob = doc.output("blob");
                        zip.file(`${safeName}.pdf`, pdfBlob);
                    }

                    // Generate ZIP blob and trigger download
                    const content = await zip.generateAsync({ type: "blob" });

                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(content);
                    link.download = "QR Codes By Company.zip";
                    link.click();
                    this.loading.generatePDF = false;

                    URL.revokeObjectURL(link.href);
                    Swal.close();
                    Swal.fire({
                        title: "Success!",
                        text: "",
                        icon: "success"
                    });
                }
                else{
                    if(multiple_guest){
                        this.loading.massPdf = true;
                        if(zipped_per_guest == 0){
                            let payload = {
                                url: 'event-participants',
                                ...this.filters,
                                guest_list_search: this.filterValue.guest_list_search,
                                guest_list_search_employee_id: this.filterValue.guest_list_search_employee_id,
                            };
    
                            this.loading.generatePDF = true;
    
                            this.$store.dispatch('urlGet', payload).then(async (res) => {
                                const grouped = {};
    
                                // 1. Group data by company_id
                                for (const guest of res.data) {
                                    if (!grouped[guest.company_id]) grouped[guest.company_id] = [];
                                    grouped[guest.company_id].push(guest);
                                }
    
                                const zip = new JSZip();
                                const companyList = Object.entries(grouped); // [ [company_id, guests], ... ]
                                const totalCompanies = companyList.length;
                                let currentIndex = 0;
    
                                Swal.fire({
                                    title: 'Generating PDFs',
                                    html: 'Starting...',
                                    allowOutsideClick: false,
                                    showConfirmButton: false,
                                    didOpen: () => {
                                        Swal.showLoading();
                                    }
                                });
    
                                for (const [company_id, guests] of companyList) {
                                    currentIndex++;
                                    const percent = Math.round((currentIndex / totalCompanies) * 100);
    
                                    const companyName = guests[0]?.company_name || `Company_${company_id}`; // fallback name
    
                                    Swal.update({
                                        html: `
                                            <div style="font-size: 16px;">
                                                <div class="swal2-loader" style="margin-bottom: 15px;"></div>
                                                Processing: <b>${companyName}</b><br>
                                                Progress: <b>${percent}%</b> (${currentIndex} of ${totalCompanies})
                                            </div>
                                        `
                                    });
    
                                    const doc = new jsPDF();
                                    const pageWidth = doc.internal.pageSize.getWidth();
                                    const margin = 10;
                                    let isFirstPage = true;
    
                                    for (const guest of guests) {
                                        if (!isFirstPage) doc.addPage();
                                        isFirstPage = false;

                                        const maxWidth = pageWidth - 40; // 20 padding on each side
                                        const fontSize = 19;

                                        doc.setFontSize(fontSize);
                                        doc.setFont('Helvetica', 'bold');

                                        const textWidth = doc.getTextWidth(companyName);

                                        // Check if the text fits within the maxWidth
                                        if (textWidth <= maxWidth) {
                                        // Fits in one line, center it
                                        doc.text(companyName, pageWidth / 2, 20, { align: 'center' });
                                        } else {
                                        // Too long, wrap to next line
                                        const lines = doc.splitTextToSize(companyName, maxWidth);
                                        doc.text(lines, pageWidth / 2, 20, { align: 'center' });
                                        }

                                        const qrDataUrl = await QRCode.toDataURL(guest.unique_code, {
                                            width: 500,
                                            margin: 1
                                        });
    
                                        const imageWidth = this.qr_code.width;
                                        const imageHeight = this.qr_code.height;
                                        const x = (pageWidth - imageWidth) / 2;
                                        const y = this.qr_code.start_y;
    
                                        doc.addImage(qrDataUrl, 'PNG', x, y, imageWidth, imageHeight);
    
                                        doc.setFontSize(18);
                                        doc.setFont('Helvetica', 'bold');
                                        const guestName = `GUEST NAME: ${guest.full_name || "N/A"}`;
                                        const tableNum = `Table#: ${guest.table_num || "N/A"}`;
                                        const uniqueCode = `UNIQUE CODE: ${guest.unique_code}`;
    
                                        doc.text(guestName, pageWidth / 2, y + imageHeight + 25, { align: 'center' });
                                        doc.text(tableNum, pageWidth / 2, y + imageHeight + 35, { align: 'center' });
                                        doc.text(uniqueCode, pageWidth / 2, y + imageHeight + 45, { align: 'center' });
                                    }
    
                                    const safeName = companyName.replace(/[\\/:*?"<>|]/g, "_");
                                    const pdfBlob = doc.output("blob");
                                    zip.file(`${safeName}.pdf`, pdfBlob);
                                }
    
                                const content = await zip.generateAsync({ type: "blob" });
    
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(content);
                                link.download = "QR Codes By Company.zip";
                                link.click();
    
                                this.loading.generatePDF = false;
                                URL.revokeObjectURL(link.href);
    
                                Swal.close();
                                Swal.fire({
                                    title: "Success!",
                                    text: "PDFs have been generated and zipped.",
                                    icon: "success"
                                });
                                this.loading.massPdf = false;
                            });
                        }else{
                            if(this.selected_for_qr_generation.length == 0){
                                Swal.fire({
                                    title: 'No Guest To Generate',
                                    text: 'Please Select Guest/s from the checkbox',
                                    icon: 'warning'
                                });
                                this.loading.massPdf = false;
                                return false;
                            }
                            let payload = {
                                url: 'getGuestUniqueCode',
                                guest_id: this.selected_for_qr_generation.map(e=> e.id),
                                by_company: by_company
                            };
                            Swal.fire({
                                title: 'Generating QR',
                                html: 'Starting...',
                                allowOutsideClick: false,
                                showConfirmButton: false,
                                didOpen: () => {
                                    Swal.showLoading();
                                }
                            });
                            await this.$store.dispatch("urlPost", payload).then(async (response) => {
                                this.loading.generatePDF = true;

                                const zip = new JSZip();

                                // STEP 1: Group guests by company_name
                                const grouped = response.reduce((acc, guest) => {
                                    const company = guest.company_name || "Unknown Company";
                                    if (!acc[company]) acc[company] = [];
                                    acc[company].push(guest);
                                    return acc;
                                }, {});

                                // STEP 2: Loop through each company and its guests
                                for (const [companyName, guests] of Object.entries(grouped)) {
                                    const safeCompanyName = companyName.replace(/[\\/:*?"<>|]/g, "_");
                                    const companyFolder = zip.folder(safeCompanyName);

                                    for (const guest of guests) {
                                        const canvas = document.createElement("canvas");
                                        const ctx = canvas.getContext("2d");

                                        const canvasWidth = 600;
                                        const canvasHeight = 800;
                                        canvas.width = canvasWidth;
                                        canvas.height = canvasHeight;

                                        ctx.fillStyle = "#ffffff";
                                        ctx.fillRect(0, 0, canvasWidth, canvasHeight);

                                        // Draw company name with wrapping
                                        ctx.fillStyle = "#000000";
                                        ctx.font = "bold 24px Helvetica";
                                        ctx.textAlign = "center";

                                        const maxTextWidth = canvasWidth - 80;
                                        const words = companyName.split(" ");
                                        let lines = [];
                                        let currentLine = words[0];

                                        for (let i = 1; i < words.length; i++) {
                                            const width = ctx.measureText(currentLine + " " + words[i]).width;
                                            if (width < maxTextWidth) {
                                                currentLine += " " + words[i];
                                            } else {
                                                lines.push(currentLine);
                                                currentLine = words[i];
                                            }
                                        }
                                        lines.push(currentLine);

                                        lines.forEach((line, i) => {
                                            ctx.fillText(line, canvasWidth / 2, 50 + i * 30);
                                        });

                                        // Generate QR code
                                        const qrDataUrl = await QRCode.toDataURL(guest.unique_code, {
                                            width: 250,
                                            margin: 1,
                                        });

                                        const qrImage = new Image();
                                        await new Promise((resolve) => {
                                            qrImage.onload = resolve;
                                            qrImage.src = qrDataUrl;
                                        });

                                        const qrX = (canvasWidth - 250) / 2;
                                        const qrY = 150;
                                        ctx.drawImage(qrImage, qrX, qrY, 250, 250);

                                        // Guest details
                                        ctx.font = "bold 20px Helvetica";
                                        ctx.fillText(`GUEST NAME: ${guest.full_name || "N/A"}`, canvasWidth / 2, qrY + 300);
                                        ctx.fillText(`Table#: ${guest.table_num || "N/A"}`, canvasWidth / 2, qrY + 340);
                                        ctx.fillText(`UNIQUE CODE: ${guest.unique_code}`, canvasWidth / 2, qrY + 380);

                                        // Convert to blob and save to ZIP
                                        const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
                                        const safeGuestName = (guest.full_name || "guest").replace(/[\\/:*?"<>|]/g, "_");
                                        companyFolder.file(`${safeGuestName}.png`, blob);
                                    }
                                }

                                // STEP 3: Generate and download the ZIP
                                const content = await zip.generateAsync({ type: "blob" });
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(content);
                                link.download = "QR Images By Guest.zip";
                                link.click();

                                URL.revokeObjectURL(link.href);
                                this.loading.generatePDF = false;
                                this.loading.massPdf = false;

                                Swal.close();
                                Swal.fire({
                                    title: "Success!",
                                    text: "ZIP file has been generated by company folders.",
                                    icon: "success"
                                });
                            });


                        }
                    }else{
                        let payload = {
                            url: 'getGuestUniqueCode',
                            guest_id: item.id,
                            by_company: by_company
                        };
    
                        const doc = new jsPDF();
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const pageHeight = doc.internal.pageSize.getHeight();
                        const margin = 10;
                        
                        await this.$store.dispatch("urlPost", payload).then(async (response) => {
                            for (const guest of response) {
                                // Generate QR code as image
                                const qrDataUrl = await QRCode.toDataURL(guest.unique_code, {
                                    width: 500,
                                    margin: 1
                                });

                                // Create canvas
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');

                                canvas.width = 800;
                                canvas.height = 1000;

                                // Background (optional)
                                ctx.fillStyle = "#FFFFFF";
                                ctx.fillRect(0, 0, canvas.width, canvas.height);

                                // Draw company name
                                ctx.font = "bold 24px Helvetica";
                                ctx.textAlign = "center";
                                ctx.fillStyle = "#000000";
                                ctx.fillText(item.company_name, canvas.width / 2, 50);

                                // Draw QR image
                                const qrImage = new Image();
                                qrImage.src = qrDataUrl;

                                await new Promise(resolve => {
                                    qrImage.onload = () => {
                                        const imgWidth = 350;
                                        const imgHeight = 350;
                                        const x = (canvas.width - imgWidth) / 2;
                                        const y = 100;
                                        ctx.drawImage(qrImage, x, y, imgWidth, imgHeight);

                                        // Draw guest details
                                        ctx.font = "bold 20px Helvetica";
                                        ctx.fillText(`GUEST NAME: ${guest.full_name || 'N/A'}`, canvas.width / 2, y + imgHeight + 40);
                                        ctx.fillText(`TABLE#: ${guest.table_num || 'N/A'}`, canvas.width / 2, y + imgHeight + 70);
                                        ctx.fillText(`UNIQUE CODE: ${guest.unique_code}`, canvas.width / 2, y + imgHeight + 100);

                                        const imgDataUrl = canvas.toDataURL("image/png");

                                        const img = document.createElement('img');
                                        img.src = imgDataUrl;
                                        img.hidden = true;
                                        document.body.appendChild(img);

                                        const a = document.createElement("a");
                                        a.href = imgDataUrl;
                                        a.download = `${guest.full_name || 'guest'}.png`;
                                        a.click();

                                        resolve();
                                    };
                                });
                            }
                        });
                    }
                }
            },
            async generateClientQR(){
                const qrDataUrl = await QRCode.toDataURL(`${process.env.VUE_APP_API_HOST_CLIENT}`, {
                    width: 1000, // Increase width for higher quality
                    margin: 1
                });

                const link = document.createElement('a');
                link.href = qrDataUrl;
                link.download = `${this.dropdowns.event_list.find((x) => x.id == this.GET_EVENT_ID)?.name}.png`; // Name of the file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            async getRaffleGroupDropdown(){
				let payload = {
					url: 'getAllRaffleGroup'
				}
				await this.$store.dispatch('urlGet', payload).then((res)=>{
					this.dropdowns.raffle_group_list = res
                    this.$store.commit('RAFFLE_GROUP_SELECTION', res);
                    if(!res){
                        this.addRaffleGroupItem()
                    }else{
					    this.raffle_groups = res
                    }
				});
			},
            raffleGroupDialogTrigger(value){
                this.raffleGroupDialog = value;
            },
            upsertRaffleGroup(){
				this.raffleGroupDialogTrigger(false);
				let payload = {
					url: 'upsertRaffleGroup',
					items: this.raffle_groups,
					event_id: this.GET_EVENT_ID
				}
				this.$store.dispatch('urlPost', payload).then((response)=>{
					this.$store.commit('NEW_MASTER_DATA', true)
                    this.getRaffleGroupDropdown();
					Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
				})
			},
            addRaffleGroupItem(){
                if(this.raffle_groups.length != 0){
                    this.raffle_groups.push({
                        code: '',
                        name: '',
                    })
                }
            },
            async getRafflePrizeAll(){
                let payload = {
					url: 'getRafflePrizeAll'
				}
				await this.$store.dispatch('urlPost', payload).then((res)=>{
					this.dropdowns.raffle_list_all = res.data
				});
            },
            selectAllGuest(item){
                this.items.forEach(el =>{
                    el.selected = item.value
                })
                this.selected_for_qr_generation = this.items.filter(e=> e.selected);
                console.log(this.selected_for_qr_generation)
            },
            addRemoveGuestToMassGenerate(item){
                // item.selected = !item.selected;
                // console.log(item.selected);
                // this.selected_for_qr_generation.push(item)
                this.selected_for_qr_generation = this.items.filter(e=> e.selected);
                console.log(this.selected_for_qr_generation)
                this.$forceUpdate();
            },
            checkImagePathLogo(image_path) {
                return process.env.VUE_APP_API_HOST + "/" + image_path
			},
			extractExcelImages(workbook, worksheet) {
				const map = new Map();
				if (!worksheet?.getImages) {
					return map;
				}
				const resolveImageById = (imageId) => {
					if (typeof workbook.getImage === 'function') {
						const resolved = workbook.getImage(imageId);
						if (resolved) {
							return resolved;
						}
					}
					const mediaItems = workbook?.model?.media ?? [];
					return mediaItems.find(media => media.id === imageId);
				};
				const images = worksheet.getImages();
				images.forEach(img => {
					const image = resolveImageById(img.imageId);
					if (!image) {
						return;
					}
					const range = img.range || {};
					const rowIndex = (range.tl?.row ?? range.row ?? 0) + 1;
					const normalizedRow = Math.max(1, Math.round(rowIndex));
					const base64 = this.convertExcelBufferToBase64(image);
					map.set(normalizedRow, {
						dataUrl: base64 || '',
						hasImage: true
					});
				});
				return map;
			},
			convertExcelBufferToBase64(image) {
				if (!image) {
					return '';
				}
				if (typeof image.base64 === 'string' && image.base64 !== '') {
					return `data:${image.contentType || 'image/png'};base64,${image.base64}`;
				}
				if (typeof image.buffer === 'string' && image.buffer !== '') {
					return `data:${image.contentType || 'image/png'};base64,${image.buffer}`;
				}
				if (typeof image.data === 'string' && image.data !== '') {
					return `data:${image.contentType || 'image/png'};base64,${image.data}`;
				}
				let uint8Array = null;
				if (image.buffer instanceof ArrayBuffer) {
					uint8Array = new Uint8Array(image.buffer);
				} else if (image.buffer instanceof Uint8Array) {
					uint8Array = image.buffer;
				} else if (Array.isArray(image.buffer)) {
					uint8Array = Uint8Array.from(image.buffer);
				} else if (image.buffer?.data) {
					uint8Array = Uint8Array.from(image.buffer.data);
				} else if (Array.isArray(image.data)) {
					uint8Array = Uint8Array.from(image.data);
				} else if (image.data instanceof ArrayBuffer) {
					uint8Array = new Uint8Array(image.data);
				}
				if (!uint8Array) {
					return '';
				}
				let binary = '';
				const chunk = 0x8000;
				for (let i = 0; i < uint8Array.length; i += chunk) {
					const slice = uint8Array.subarray(i, i + chunk);
					binary += String.fromCharCode.apply(null, slice);
				}
				const base64 = btoa(binary);
				return `data:${image.contentType || 'image/png'};base64,${base64}`;
			},
			itemHasImage(item) {
				if (!item) {
					return false;
				}
				const base64 = typeof item.image_base64 === 'string' ? item.image_base64.trim() : '';
				if (base64.startsWith('data:image')) {
					return true;
				}
				if (item.has_embedded_image) {
					return true;
				}
				const path = typeof item.image_path === 'string' ? item.image_path.trim() : '';
				if (!path || path.toLowerCase().includes('paste image')) {
					return false;
				}
				return path.startsWith('data:image') || path.startsWith('images/') || path.startsWith('/images/') || path.startsWith('http');
			},
			getRaffleItemLabel(item, index) {
				const name = (item?.name || '').trim();
				if (name) {
					return name;
				}
				const code = (item?.code || '').trim();
				if (code) {
					return code;
				}
				return `Row ${index + 2}`;
			},
			getRaffleImportMissingFields(item, index) {
				const missing = [];
				if (!this.itemHasImage(item)) {
					missing.push('Image');
				}
				if (!item?.code || item.code.trim() === '') {
					missing.push('Code');
				}
				if (!item?.name || item.name.trim() === '') {
					missing.push('Name');
				}
				return missing;
			},
			removeImageBackground(base64Image) {
				return new Promise((resolve) => {
					try {
						const img = new Image();
						img.crossOrigin = 'anonymous';
						img.onload = () => {
							const canvas = document.createElement('canvas');
							canvas.width = img.width;
							canvas.height = img.height;
							const ctx = canvas.getContext('2d');
							ctx.drawImage(img, 0, 0);
							const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
							const data = imageData.data;
							for (let i = 0; i < data.length; i += 4) {
								const r = data[i];
								const g = data[i + 1];
								const b = data[i + 2];
								if (r > 240 && g > 240 && b > 240) {
									data[i + 3] = 0;
								}
							}
							ctx.putImageData(imageData, 0, 0);
							resolve(canvas.toDataURL('image/png'));
						};
						img.onerror = () => resolve(base64Image);
						img.src = base64Image;
					} catch (error) {
						console.error('Background removal failed', error);
						resolve(base64Image);
					}
				});
			},
		  },
  
		  computed: {
				availableRafflePrizes() {
					// Filter out drawn raffles from available selection
					return this.draggable_items.filter(item => item.raffle_drawn != 1);
				},
				nonPriorityRaffleItems: {
					get() {
						// Filter out priority raffles from the normal raffle prizes table
						return this.draggable_items.filter(item => 
							!this.priorityRafflePrizes.includes(item.id)
						);
					},
					set(value) {
						// Rebuild draggable_items so non-priority items keep the newly dragged order
						const priorityItems = this.draggable_items.filter(item => this.priorityRafflePrizes.includes(item.id));
						const reorderedNonPriority = value.map((item, index) => {
							const originalItem = this.draggable_items.find(orig => orig.id === item.id) || item;
							originalItem.order = index + 1;
							return originalItem;
						});
						this.draggable_items = [...priorityItems, ...reorderedNonPriority];
					}
				},
				selectedPriorityRaffles: {
					get() {
						// Get full details of selected priority raffles, sorted by priority_order
						return this.draggable_items
							.filter(item => this.priorityRafflePrizes.includes(item.id))
							.sort((a, b) => {
								// Sort by priority_order first, then by order as fallback
								const orderA = a.priority_order !== null && a.priority_order !== undefined ? a.priority_order : 9999;
								const orderB = b.priority_order !== null && b.priority_order !== undefined ? b.priority_order : 9999;
								return orderA - orderB;
							});
					},
					set(value) {
						// Update priority_order when items are reordered
						value.forEach((item, index) => {
							const originalItem = this.draggable_items.find(orig => orig.id === item.id);
							if (originalItem) {
								originalItem.priority_order = index + 1;
							}
						});
					}
				},
				raffleImportIssues() {
					return this.batchRafflePrizeItems
						.map((item, index) => {
							const missingFields = this.getRaffleImportMissingFields(item, index);
							if (missingFields.length) {
								return {
									item,
									index,
									label: this.getRaffleItemLabel(item, index),
									missingFields
								};
							}
							return null;
						})
						.filter(Boolean);
				},
				hasIncompleteRaffleImport() {
					return this.raffleImportIssues.length > 0;
				},
			filteredRaffleImportItems() {
				if (this.uploadRafflePrizesFilterIncomplete) {
					return this.raffleImportIssues.map(entry => entry.item);
				}
				return this.batchRafflePrizeItems;
			},
			filteredGuestItems() {
				let filtered = this.items;
				
				// Filter by employee_id
				if (this.filterValue.guest_list_search_employee_id && this.filterValue.guest_list_search_employee_id.trim() !== '') {
					const employeeIdSearch = this.filterValue.guest_list_search_employee_id.toLowerCase().trim();
					filtered = filtered.filter(item => 
						item.employee_id && item.employee_id.toString().toLowerCase().includes(employeeIdSearch)
					);
				}
				
				// Filter by name (first_name, middle_name, last_name, or full_name)
				if (this.filterValue.guest_list_search && this.filterValue.guest_list_search.trim() !== '') {
					const nameSearch = this.filterValue.guest_list_search.toLowerCase().trim();
					filtered = filtered.filter(item => {
						const fullName = (item.full_name || '').toLowerCase();
						const firstName = (item.first_name || '').toLowerCase();
						const middleName = (item.middle_name || '').toLowerCase();
						const lastName = (item.last_name || '').toLowerCase();
						return fullName.includes(nameSearch) || 
							   firstName.includes(nameSearch) || 
							   middleName.includes(nameSearch) || 
							   lastName.includes(nameSearch);
					});
				}
				
				// Filter by table number
				if (this.filterValue.guest_list_search_table_search && this.filterValue.guest_list_search_table_search.trim() !== '') {
					const tableSearch = this.filterValue.guest_list_search_table_search.toString().trim();
					filtered = filtered.filter(item => 
						item.table_num && item.table_num.toString().includes(tableSearch)
					);
				}
				
				return filtered;
			},
			...mapGetters([
					"GET_NEW_MASTER_DATA",
					"GET_EVENT_ID",
					"GET_EVENT_NAME",
					"GET_PREFERENCES",
					"authStatus"
				]),
				usernameRules() {
					return [
					value => !!value || 'Username is required'
					];
				},
				computedHeight() {
					return `${this.screenHeight * 0.75}px`;
				},
				showScrollToTop() {
					return this.isContentScrollable && this.isScrolled;
				},
				passwordRules() {
					return [
						value => !!value || 'Password is required'
					];
				},
				guest_headers() {
					return this.headers.filter(header => header.grouping.includes(this.settings.data_grouping));
				},
				import_guest_headers_filtered() {
					return this.import_guest_headers.filter(header => header.grouping.includes(this.settings.data_grouping));
				}
		  },
  
		  watch:{
			  GET_NEW_MASTER_DATA:{
				  handler(val){
					  if(val){
						  if(this.current_index == 5){
                            this.getTableData(5, {gender: this.nominee_tabs[this.n_tab].gender})
                            this.$store.commit('NEW_MASTER_DATA', false)
						  }else{
                            this.getTableData(this.current_index);
                            this.getEventDropdowns()
                            this.$store.commit('NEW_MASTER_DATA', false)
                            this.getCompanyDropdowns();
                            this.getRafflePrizeAll();
						  }
					  }
				  }
			  },
			  'options.guest_list':{
				  handler(val){
					  this.getTableData(this.tab.index);
				  }
			  },
			  GET_EVENT_ID:{
				  handler(val){
					  if(val){
						  this.getTableData(this.tab.index);
						  this.getGroupingSettings();
						  this.getCompanyDropdowns();
					  }
				  }
			  },
			  'settings.data_grouping':{
				  handler(val){
				  }
			  },
			  uploadParticipantsDialog:{
				  handler(val){
					  if(!val){
						  this.batchAdditionItems = [];
					  }
				  }
			  },
			  uploadRafflePrizesDialog:{
				  handler(val){
					  if(!val){
						  this.batchRafflePrizeItems = [];
						  this.rafflePrizeLoaded = true;
						  this.rafflePrizeHaveImg = false;
						  this.rafflePrizeLoadingText = '';
						  this.rafflePrizeUploadedFile = null;
                          this.uploadRafflePrizesFilterIncomplete = false;
						  if(this.$refs.rafflePrizeFile){
							  this.$refs.rafflePrizeFile.value = '';
						  }
					  }
				  }
			  },
			  'filterValue.ticket_num':{
				  handler(val){
					  this.filterCompanyByTicket()
				  },
				  deep: true,
				  immediate: true,
			  },
		  }
	  }
  </script>
  
  <style>
	.custom-swal-popup {
		max-height: 80vh;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}

	.custom-swal-title {
		position: sticky;
		top: 0;
		z-index: 1;
		padding: 10px 0;
		margin: 0;
	}

	.swal-subtitle {
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 10px;
		color: #f7f7f7;
	}

	.thead {
		display: table; 
		width: calc(100% - 17px);
	}

	.sticky-header {
		position: sticky;
		width: 5%; 
		top: 0;
		z-index: 10;
		background-color: 0 2px 4px rgba(22, 20, 20, 0.4);
		border-bottom: 2px solid #181717;
	}

	.table-container {
		position: relative;
		max-height: 400px; 
		overflow-y: auto; 
	}

	.custom-swal-html {
		flex: 1;
		overflow-y: auto;
		margin-top: 10px;
	}

	.swal-scrollable-content {
		max-height: 60vh;
		overflow-y: auto;
		padding: 10px;
	}

	.fixed-header {
		position: sticky; 
		top: 0; 
		z-index: 10; 
	}

	.v-simple-table th, .v-simple-table td {
		text-align: center; 
		padding: 8px;
	}

	.v-simple-table thead th {
		position: sticky; 
		top: 0; 
		z-index: 10;
	}

	.fixed-header th {
		padding: 10px; 
	}

	.v-col {
		overflow-y: auto;
		max-height: 400px;
	}

	.orange-bg { 
		background-color: #17468f; height: 50px;
	} 
	.orange-bg .v-btn, .orange-bg .v-text-field .v-text-field__slot{
		color: black; }
	.my-page .v-label  {
		color: black !important;
	}
	.flipped-icon {
		transform: scaleX(-1);
	}
	.black-text {
		color: black !important;
	}
	.black-text {
		color: black !important;
	}
	.black-text-field input {
		color: black !important;
	}
	.orange-text-field input {
		color: #17468f !important;
	}
	.Adaptive-text-LogIn {
		font-size: 22px;
		justify-content: center;
	}
	@media (max-width: 600px) {
		.Adaptive-text-Note {
			font-size: 16px; 
		}
	}
	.orange-text {
		color: rgb(29, 20, 16);
	}
	.dotted-border-orange {
		border: 1px dotted rgb(255, 255, 255);
	}
	.v-text-field--outlined >>> fieldset {
		border-color: rgba(192, 0, 250, 0.986);
	}
	.base-color {
		color: black;
	}
	.small-header {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.sticky-header {
		position: -webkit-sticky; 
		position: sticky;
		top: 0;
		z-index: 999;
		box-shadow: 0px 2px 2px -1px rgba(0, 0, 0, 0.4);
	}
	.swal-scrollable-content {
		max-height: 40vh; 
		overflow-y: auto;
	}
	
	.fixed-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1; 
	}
	.fixed-menu {
		background-color: #333; 
		padding: 0px; 
	}
	.fixed-tabs {
		background-color: #222; 
		padding: 0px; 
	}
	.main-content {
		margin-top: 11px; 
		width:100%;
	}
	.back-to-top-btn {
		position: fixed;
		bottom: 20px;
		right: 20px;
		z-index: 1000;
		transition: opacity 0.3s;
	}

	/* Raffle Order Dialog Styles */
	.raffle-order-dialog-card {
		border-radius: 12px !important;
		overflow: hidden;
	}

	.priority-raffle-card,
	.normal-raffle-card {
		transition: box-shadow 0.3s ease;
	}

	.priority-raffle-card:hover,
	.normal-raffle-card:hover {
		box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
	}

	/* Custom Scrollbar Styles */
	.priority-table-container::-webkit-scrollbar,
	.normal-table-container::-webkit-scrollbar,
	.raffle-order-dialog-card .v-card-text::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.priority-table-container::-webkit-scrollbar-track,
	.normal-table-container::-webkit-scrollbar-track,
	.raffle-order-dialog-card .v-card-text::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.05);
		border-radius: 4px;
	}

	.priority-table-container::-webkit-scrollbar-thumb,
	.normal-table-container::-webkit-scrollbar-thumb,
	.raffle-order-dialog-card .v-card-text::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 4px;
		transition: background 0.3s ease;
	}

	.priority-table-container::-webkit-scrollbar-thumb:hover,
	.normal-table-container::-webkit-scrollbar-thumb:hover,
	.raffle-order-dialog-card .v-card-text::-webkit-scrollbar-thumb:hover {
		background: rgba(255, 255, 255, 0.3);
	}

	/* Table Row Hover Effect */
	.table-row-hover:hover {
		background-color: rgba(255, 255, 255, 0.05) !important;
		transition: background-color 0.2s ease;
	}

	/* Priority Table Styling */
	.priority-table .v-data-table__wrapper {
		border-radius: 4px;
	}

	.priority-table table {
		border-collapse: separate;
		border-spacing: 0;
	}

	.priority-table tbody tr {
		transition: background-color 0.2s ease;
	}

	.priority-table tbody tr:hover {
		background-color: rgba(25, 118, 210, 0.1) !important;
	}

	/* Normal Table Styling */
	.normal-table-container .v-simple-table {
		border-radius: 0;
	}

	.normal-table-container .v-simple-table tbody tr {
		transition: background-color 0.2s ease;
	}

	.normal-table-container .v-simple-table tbody tr:hover {
		background-color: rgba(255, 255, 255, 0.05) !important;
	}

	/* Responsive adjustments */
	@media (max-width: 960px) {
		.raffle-order-dialog-card {
			width: 95% !important;
		}
		
		.priority-table-container,
		.normal-table-container {
			max-height: 250px !important;
		}
	}
  </style>
	